/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * A list of task types a customer may be required to complete in order to facilitate
 * their transaction, both OBO and non-OBO
 */
export enum BuyClosingTaskType {
  APPRAISAL = "APPRAISAL",
  BUY_DIRECT_EARNEST_MONEY = "BUY_DIRECT_EARNEST_MONEY",
  BUY_DIRECT_FINAL_WALKTHROUGH = "BUY_DIRECT_FINAL_WALKTHROUGH",
  BUY_DIRECT_INFO_TITLE_ESCROW = "BUY_DIRECT_INFO_TITLE_ESCROW",
  BUY_DIRECT_REVIEW_DISCLOSURES = "BUY_DIRECT_REVIEW_DISCLOSURES",
  BUY_DIRECT_SCHEDULE_INSPECTION = "BUY_DIRECT_SCHEDULE_INSPECTION",
  BUY_DIRECT_SIGN_CONTRACT = "BUY_DIRECT_SIGN_CONTRACT",
  FEED_FILTERS = "FEED_FILTERS",
  INFORMATION_CONFIRMATION = "INFORMATION_CONFIRMATION",
  INSPECTIONS = "INSPECTIONS",
  LOAN_APPLICATION = "LOAN_APPLICATION",
  LOAN_FINALIZATION = "LOAN_FINALIZATION",
  MARKET_TRENDS = "MARKET_TRENDS",
  NOT_SPECIFIED = "NOT_SPECIFIED",
  RESALE_CONTRACT = "RESALE_CONTRACT",
  UTILITIES = "UTILITIES",
}

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 * 
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export enum GoogleProtobuf_NullValue {
  NULL_VALUE = "NULL_VALUE",
}

export enum ListingTag {
  BUY_DIRECT_ELIGIBLE = "BUY_DIRECT_ELIGIBLE",
  BUY_DIRECT_MULTIPLE_OFFERS = "BUY_DIRECT_MULTIPLE_OFFERS",
  BUY_DIRECT_SALE_PENDING = "BUY_DIRECT_SALE_PENDING",
  BUY_DIRECT_VERBAL_AGREEMENT = "BUY_DIRECT_VERBAL_AGREEMENT",
}

export enum OdProtosBallparkData_Source {
  BULK_OVM = "BULK_OVM",
  REALTY_TRAC = "REALTY_TRAC",
  UNKNOWN_SOURCE = "UNKNOWN_SOURCE",
}

export enum OdProtosBuyerData_Document_FileScanStatus {
  CLEAN = "CLEAN",
  FILE_SCAN_STATUS_UNKNOWN = "FILE_SCAN_STATUS_UNKNOWN",
  INFECTED = "INFECTED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum OdProtosBuyerData_Offer_FundingSource {
  CASH = "CASH",
  MORTGAGE = "MORTGAGE",
  UNKNOWN_FUNDING_SOURCE = "UNKNOWN_FUNDING_SOURCE",
}

export enum OdProtosBuyerData_Offer_State {
  AWAITING_RESPONSE = "AWAITING_RESPONSE",
  AWAITING_SIGNATURE = "AWAITING_SIGNATURE",
  CANCELED_BEFORE_SUBMITTING = "CANCELED_BEFORE_SUBMITTING",
  CANCELED_BY_BUYER = "CANCELED_BY_BUYER",
  CANCELED_ESCROW = "CANCELED_ESCROW",
  CLOSED_ESCROW = "CLOSED_ESCROW",
  COUNTERED = "COUNTERED",
  DRAFT = "DRAFT",
  INCOMPLETE = "INCOMPLETE",
  IN_CONTRACT = "IN_CONTRACT",
  IN_REVIEW = "IN_REVIEW",
  READY_TO_SUBMIT = "READY_TO_SUBMIT",
  REJECTED = "REJECTED",
  SUBMITTED_AS_BACKUP = "SUBMITTED_AS_BACKUP",
  UNKNOWN = "UNKNOWN",
}

export enum OdProtosBuyerData_Property_PoolType {
  ABOVE_GROUND = "ABOVE_GROUND",
  COMMUNITY = "COMMUNITY",
  NONE = "NONE",
  NO_POOL = "NO_POOL",
  PRIVATE = "PRIVATE",
  PRIVATE_SPA = "PRIVATE_SPA",
  UNKNOWN_POOL_TYPE = "UNKNOWN_POOL_TYPE",
}

export enum OdProtosBuyerData_Property_PropertyType {
  APARTMENT = "APARTMENT",
  COMMERCIAL = "COMMERCIAL",
  HOME = "HOME",
  LAND = "LAND",
  MOBILE_HOME = "MOBILE_HOME",
  MULTI_FAMILY = "MULTI_FAMILY",
  RENTAL = "RENTAL",
  TOWNHOME = "TOWNHOME",
  UNCLASSIFIED = "UNCLASSIFIED",
  UNKNOWN_PROPERTY_TYPE = "UNKNOWN_PROPERTY_TYPE",
}

export enum OdProtosBuyerData_User_CreditRating {
  AVERAGE = "AVERAGE",
  EXCELLENT = "EXCELLENT",
  GOOD = "GOOD",
  LOW = "LOW",
  UNKNOWN_CREDIT_RATING = "UNKNOWN_CREDIT_RATING",
}

export enum OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters {
  ACTIVE = "ACTIVE",
  ALL = "ALL",
  INACTIVE = "INACTIVE",
}

export enum OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferFinancing_FundingSource {
  CASH = "CASH",
  MORTGAGE = "MORTGAGE",
  UNKNOWN_FUNDING_SOURCE = "UNKNOWN_FUNDING_SOURCE",
}

export enum OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey {
  SORT_KEY_DEFAULT = "SORT_KEY_DEFAULT",
  SORT_KEY_POPULAR_AT_DESC = "SORT_KEY_POPULAR_AT_DESC",
}

/**
 * Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry
 */
export enum OdProtosBuyerServicesBuyer_PropertyRequests_SortKey {
  SORT_KEY_CURRENT_LIST_PRICE_ASC = "SORT_KEY_CURRENT_LIST_PRICE_ASC",
  SORT_KEY_CURRENT_LIST_PRICE_DESC = "SORT_KEY_CURRENT_LIST_PRICE_DESC",
  SORT_KEY_DEFAULT = "SORT_KEY_DEFAULT",
  SORT_KEY_LISTED_AT_ASC = "SORT_KEY_LISTED_AT_ASC",
  SORT_KEY_LISTED_AT_DESC = "SORT_KEY_LISTED_AT_DESC",
  SORT_KEY_TOTAL_LIVING_SQ_FT_ASC = "SORT_KEY_TOTAL_LIVING_SQ_FT_ASC",
  SORT_KEY_TOTAL_LIVING_SQ_FT_DESC = "SORT_KEY_TOTAL_LIVING_SQ_FT_DESC",
}

export enum OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  UNKNOWN_STATUS = "UNKNOWN_STATUS",
}

export enum OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter {
  ALL = "ALL",
  FUTURE = "FUTURE",
  NEEDS_FOLLOWUP = "NEEDS_FOLLOWUP",
  PAST = "PAST",
}

export enum OdProtosCabinetData_Asset_Type {
  DOCUMENT = "DOCUMENT",
  IMAGE = "IMAGE",
  UNKNOWN = "UNKNOWN",
  VIDEO = "VIDEO",
}

/**
 * The names must be the uppercase versions of the market identifiers in web.
 * Update region.proto if any market is added/removed from here.
 */
export enum OdProtosCommonMarket_Market {
  ALBUQUERQUE_NM = "ALBUQUERQUE_NM",
  ASHEVILLE_NC = "ASHEVILLE_NC",
  ATLANTA = "ATLANTA",
  AUSTIN = "AUSTIN",
  BAKERSFIELD_CA = "BAKERSFIELD_CA",
  BALTIMORE_MD = "BALTIMORE_MD",
  BIRMINGHAM_AL = "BIRMINGHAM_AL",
  BOISE = "BOISE",
  BOSTON_MA = "BOSTON_MA",
  CENTRAL_CALIFORNIA_CA = "CENTRAL_CALIFORNIA_CA",
  CHARLESTON_SC = "CHARLESTON_SC",
  CHARLOTTE = "CHARLOTTE",
  CHATTANOOGA = "CHATTANOOGA",
  CHICAGO_IL = "CHICAGO_IL",
  CINCINNATI_OH = "CINCINNATI_OH",
  CINCINNATI_OK = "CINCINNATI_OK",
  CLARKSVILLE_KY_TN = "CLARKSVILLE_KY_TN",
  CLEVELAND_OH = "CLEVELAND_OH",
  COLORADO_SPRINGS_CO = "COLORADO_SPRINGS_CO",
  COLUMBIA_SC = "COLUMBIA_SC",
  COLUMBUS_OH = "COLUMBUS_OH",
  CORPUS_CHRISTI_TX = "CORPUS_CHRISTI_TX",
  DALLAS = "DALLAS",
  DENVER = "DENVER",
  DETROIT_MI = "DETROIT_MI",
  FORT_COLLINS_CO = "FORT_COLLINS_CO",
  GREENSBORO_NC = "GREENSBORO_NC",
  GREENVILLE_SC = "GREENVILLE_SC",
  HOUSTON = "HOUSTON",
  HUNTSVILLE_AL = "HUNTSVILLE_AL",
  INDIANAPOLIS_IN = "INDIANAPOLIS_IN",
  JACKSONVILLE = "JACKSONVILLE",
  JOHNSON_CITY_TN = "JOHNSON_CITY_TN",
  KANSAS_CITY = "KANSAS_CITY",
  KILLEEN_TX = "KILLEEN_TX",
  KNOXVILLE_TN = "KNOXVILLE_TN",
  LAS_VEGAS = "LAS_VEGAS",
  LOS_ANGELES = "LOS_ANGELES",
  LOUISVILLE_IN_KY = "LOUISVILLE_IN_KY",
  MEMPHIS_TN = "MEMPHIS_TN",
  MIAMI_FL = "MIAMI_FL",
  MILWAUKEE_WAUKESHA_WI = "MILWAUKEE_WAUKESHA_WI",
  MINNEAPOLIS = "MINNEAPOLIS",
  NASHVILLE = "NASHVILLE",
  NEW_YORK_NEW_JERSEY = "NEW_YORK_NEW_JERSEY",
  NORTHERN_COLORADO = "NORTHERN_COLORADO",
  OKLAHOMA_CITY_OK = "OKLAHOMA_CITY_OK",
  ORLANDO = "ORLANDO",
  PALM_BAY_FL = "PALM_BAY_FL",
  PHILADELPHIA_PA = "PHILADELPHIA_PA",
  PHOENIX = "PHOENIX",
  PORTLAND = "PORTLAND",
  PRESCOTT_AZ = "PRESCOTT_AZ",
  PROVIDENCE_RI = "PROVIDENCE_RI",
  RALEIGH = "RALEIGH",
  RENO_NV = "RENO_NV",
  RICHMOND_VA = "RICHMOND_VA",
  RIVERSIDE = "RIVERSIDE",
  SACRAMENTO = "SACRAMENTO",
  SALT_LAKE_CITY = "SALT_LAKE_CITY",
  SAN_ANTONIO = "SAN_ANTONIO",
  SAN_DIEGO_CA = "SAN_DIEGO_CA",
  SAVANNAH_GA = "SAVANNAH_GA",
  SEATTLE_WA = "SEATTLE_WA",
  SF_BAY_AREA = "SF_BAY_AREA",
  SOUTHWEST_FL = "SOUTHWEST_FL",
  SPRINGFIELD_MO = "SPRINGFIELD_MO",
  ST_LOUIS = "ST_LOUIS",
  TAMPA = "TAMPA",
  TUCSON = "TUCSON",
  TULSA_OK = "TULSA_OK",
  UNKNOWN = "UNKNOWN",
  WASHINGTON_DC = "WASHINGTON_DC",
  WICHITA_KS = "WICHITA_KS",
}

/**
 * Tribool is a boolean (Yes/No) with a third state (Maybe).
 */
export enum OdProtosCommonPagination_Tribool {
  MAYBE = "MAYBE",
  NO = "NO",
  YES = "YES",
}

/**
 * Next ID: 27
 */
export enum OdProtosCommonSell_OfferRequest_Source {
  AUTOMATED_AGENT_REENGAGEMENT_OFFER = "AUTOMATED_AGENT_REENGAGEMENT_OFFER",
  AUTOMATED_REENGAGEMENT_OFFER = "AUTOMATED_REENGAGEMENT_OFFER",
  EMAIL_PROSPECTING = "EMAIL_PROSPECTING",
  EXCLUSIVE_OFFERS = "EXCLUSIVE_OFFERS",
  FLYWHEEL = "FLYWHEEL",
  HOMEPAGE_RETURN_EXPERIENCE = "HOMEPAGE_RETURN_EXPERIENCE",
  HOME_RESERVE = "HOME_RESERVE",
  INCOMPLETE_INITIAL_LEAD_FLOW = "INCOMPLETE_INITIAL_LEAD_FLOW",
  INITIAL_LEAD_FLOW = "INITIAL_LEAD_FLOW",
  MOBILE_APP = "MOBILE_APP",
  OFFER_REENGAGEMENT_CAMPAIGN = "OFFER_REENGAGEMENT_CAMPAIGN",
  OFFER_REVIEW = "OFFER_REVIEW",
  OUTBOUND_OFFERS_LISTED = "OUTBOUND_OFFERS_LISTED",
  REFRESH_ADMIN = "REFRESH_ADMIN",
  REFRESH_BROKERAGE_OFFER_DASHBOARD = "REFRESH_BROKERAGE_OFFER_DASHBOARD",
  REFRESH_CORRECTED_SQ_FT_DATA = "REFRESH_CORRECTED_SQ_FT_DATA",
  REFRESH_FROM_ENG = "REFRESH_FROM_ENG",
  REFRESH_HOME_DETAILS = "REFRESH_HOME_DETAILS",
  REFRESH_OFFER_DASHBOARD = "REFRESH_OFFER_DASHBOARD",
  REFRESH_PARTNER_CTA = "REFRESH_PARTNER_CTA",
  REFRESH_PARTNER_REFERRAL = "REFRESH_PARTNER_REFERRAL",
  REFRESH_PREVIOUSLY_DENIED = "REFRESH_PREVIOUSLY_DENIED",
  REFRESH_REENGAGEMENT_EMAILS = "REFRESH_REENGAGEMENT_EMAILS",
  REFRESH_SELLER_FEEDBACK = "REFRESH_SELLER_FEEDBACK",
  REIT_BULK_REQUEST = "REIT_BULK_REQUEST",
  RETURN_TO_HUB_AUTO_REFRESH = "RETURN_TO_HUB_AUTO_REFRESH",
  UNKNOWN_OFFER_SOURCE = "UNKNOWN_OFFER_SOURCE",
}

/**
 * Next ID: 16
 */
export enum OdProtosCommonSell_SellDirectOfferRefreshStatus {
  FAIL_ACTIVE_OFFER_ON_ADDRESS = "FAIL_ACTIVE_OFFER_ON_ADDRESS",
  FAIL_ACTIVE_OFFER_REQUEST_ON_ADDRESS = "FAIL_ACTIVE_OFFER_REQUEST_ON_ADDRESS",
  FAIL_EXISTING_OFFER_NOT_FOUND = "FAIL_EXISTING_OFFER_NOT_FOUND",
  FAIL_HOME_IS_NOW_LISTED = "FAIL_HOME_IS_NOW_LISTED",
  FAIL_INSPECTION_IN_PROGRESS = "FAIL_INSPECTION_IN_PROGRESS",
  FAIL_LEAD_NOT_FOUND_SELL_DIRECT = "FAIL_LEAD_NOT_FOUND_SELL_DIRECT",
  FAIL_LEAD_NOT_QUALIFIED = "FAIL_LEAD_NOT_QUALIFIED",
  FAIL_LISTING_DETAILS_NOT_FOUND = "FAIL_LISTING_DETAILS_NOT_FOUND",
  FAIL_LWC_REFRESH_PERMISSION_DENIED = "FAIL_LWC_REFRESH_PERMISSION_DENIED",
  FAIL_MERCH_DENIED_LEAD = "FAIL_MERCH_DENIED_LEAD",
  FAIL_OFFER_NOT_EXPIRED = "FAIL_OFFER_NOT_EXPIRED",
  FAIL_OFFER_STATE_NOT_REFRESHABLE = "FAIL_OFFER_STATE_NOT_REFRESHABLE",
  FAIL_REFRESH_REQUESTED_TOO_SOON = "FAIL_REFRESH_REQUESTED_TOO_SOON",
  FAIL_UPCOMING_CALENDLY_MEETING = "FAIL_UPCOMING_CALENDLY_MEETING",
  SUCCESS = "SUCCESS",
  UNKNOWN = "UNKNOWN",
}

/**
 * Next ID: 66
 */
export enum OdProtosCommonState_State {
  AA = "AA",
  AE = "AE",
  AK = "AK",
  AL = "AL",
  AP = "AP",
  AR = "AR",
  AS = "AS",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FL = "FL",
  GA = "GA",
  GU = "GU",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MP = "MP",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  PR = "PR",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UNKNOWN = "UNKNOWN",
  UT = "UT",
  VA = "VA",
  VI = "VI",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

/**
 * defaults to USD;
 * sourced on 2017-04-27 from https: // www.iso.org/iso-4217-currency-codes.html
 */
export enum OdProtosCommon_Money_AlphabeticCurrencyCode {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BOV = "BOV",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  CHE = "CHE",
  CHF = "CHF",
  CHW = "CHW",
  CLF = "CLF",
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  COU = "COU",
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HRK = "HRK",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRO = "MRO",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  MXV = "MXV",
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SLL = "SLL",
  SOS = "SOS",
  SRD = "SRD",
  SSP = "SSP",
  STD = "STD",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  USN = "USN",
  UYI = "UYI",
  UYU = "UYU",
  UZS = "UZS",
  VEF = "VEF",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XAG = "XAG",
  XAU = "XAU",
  XBA = "XBA",
  XBB = "XBB",
  XBC = "XBC",
  XBD = "XBD",
  XCD = "XCD",
  XDR = "XDR",
  XOF = "XOF",
  XPD = "XPD",
  XPF = "XPF",
  XPT = "XPT",
  XSU = "XSU",
  XTS = "XTS",
  XUA = "XUA",
  XXX = "XXX",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZWL = "ZWL",
}

export enum OdProtosGeoDataStoreData_Zone_Type {
  CITY = "CITY",
  COUNTY = "COUNTY",
  MACRO_NEIGHBORHOOD = "MACRO_NEIGHBORHOOD",
  NEIGHBORHOOD = "NEIGHBORHOOD",
  RESIDENTIAL_BOUNDARY = "RESIDENTIAL_BOUNDARY",
  STATE = "STATE",
  SUBNEIGHBORHOOD = "SUBNEIGHBORHOOD",
  UNKNOWN = "UNKNOWN",
  ZIP_CODE = "ZIP_CODE",
}

/**
 * UNKNOWN/FULL_SIZE: Full shape is returned
 * EXCLUDE: Empty string is returned
 * SIMPLIFY: ST_Simplified shape is returned
 */
export enum OdProtosGeoDataStoreServices_ShapeGeoOption {
  EXCLUDE = "EXCLUDE",
  FULL_SIZE = "FULL_SIZE",
  SIMPLIFY = "SIMPLIFY",
  UNKNOWN = "UNKNOWN",
}

export enum OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac {
  FULL_HVAC = "FULL_HVAC",
  HEATED_ONLY = "HEATED_ONLY",
  HVAC_OTHER = "HVAC_OTHER",
  HVAC_UNKNOWN = "HVAC_UNKNOWN",
  NO_HEATING_OR_COOLING = "NO_HEATING_OR_COOLING",
}

export enum OdProtosHomeDataStore_HomeDetail_BathroomFeature {
  BATHROOM_3_4_SHOWER_ONLY = "BATHROOM_3_4_SHOWER_ONLY",
  BATHROOM_3_4_TUB_ONLY = "BATHROOM_3_4_TUB_ONLY",
  BATHROOM_BIDET = "BATHROOM_BIDET",
  BATHROOM_DOUBLE_SINK = "BATHROOM_DOUBLE_SINK",
  BATHROOM_DUAL_BATHROOMS = "BATHROOM_DUAL_BATHROOMS",
  BATHROOM_FULL_BATH = "BATHROOM_FULL_BATH",
  BATHROOM_GRANITE_COUNTERTOPS = "BATHROOM_GRANITE_COUNTERTOPS",
  BATHROOM_HALF = "BATHROOM_HALF",
  BATHROOM_JETTED_TUB = "BATHROOM_JETTED_TUB",
  BATHROOM_NONE = "BATHROOM_NONE",
  BATHROOM_NO_MAIN_BATHROOM = "BATHROOM_NO_MAIN_BATHROOM",
  BATHROOM_OTHER = "BATHROOM_OTHER",
  BATHROOM_PRIVATE_TOILET = "BATHROOM_PRIVATE_TOILET",
  BATHROOM_SAUNA = "BATHROOM_SAUNA",
  BATHROOM_SEPARATE_SHOWER_TUB = "BATHROOM_SEPARATE_SHOWER_TUB",
  BATHROOM_SHOWER_TUB_COMBO = "BATHROOM_SHOWER_TUB_COMBO",
  BATHROOM_SKYLIGHTS = "BATHROOM_SKYLIGHTS",
  BATHROOM_SOAKING_TUB = "BATHROOM_SOAKING_TUB",
  BATHROOM_UNKNOWN = "BATHROOM_UNKNOWN",
  BATHROOM_WALK_IN_CLOSETS = "BATHROOM_WALK_IN_CLOSETS",
}

/**
 * Next Room Id: 20
 */
export enum OdProtosHomeDataStore_HomeDetail_CoolingFeature {
  COOLING_AIR_CONDITION = "COOLING_AIR_CONDITION",
  COOLING_ATTIC_FAN = "COOLING_ATTIC_FAN",
  COOLING_CENTRAL = "COOLING_CENTRAL",
  COOLING_CENTRAL_ELECTRIC = "COOLING_CENTRAL_ELECTRIC",
  COOLING_CENTRAL_GAS = "COOLING_CENTRAL_GAS",
  COOLING_DUAL = "COOLING_DUAL",
  COOLING_ELECTRIC = "COOLING_ELECTRIC",
  COOLING_ENERGY_STAR = "COOLING_ENERGY_STAR",
  COOLING_EVAPORATIVE_COOLER = "COOLING_EVAPORATIVE_COOLER",
  COOLING_FAN = "COOLING_FAN",
  COOLING_GAS = "COOLING_GAS",
  COOLING_GEOTHERMAL = "COOLING_GEOTHERMAL",
  COOLING_HEAT_PUMP = "COOLING_HEAT_PUMP",
  COOLING_HIGH_EFFICIENCY = "COOLING_HIGH_EFFICIENCY",
  COOLING_MINI_SPLIT = "COOLING_MINI_SPLIT",
  COOLING_MUTLI_UNITS = "COOLING_MUTLI_UNITS",
  COOLING_NONE = "COOLING_NONE",
  COOLING_OTHER = "COOLING_OTHER",
  COOLING_PROGRAMMABLE_THERMOSTAT = "COOLING_PROGRAMMABLE_THERMOSTAT",
  COOLING_REFRIGERATION = "COOLING_REFRIGERATION",
  COOLING_UNKNOWN = "COOLING_UNKNOWN",
  COOLING_WALL_UNIT = "COOLING_WALL_UNIT",
  COOLING_WHOLE_HOUSE_FAN = "COOLING_WHOLE_HOUSE_FAN",
  COOLING_WINDOW_UNIT = "COOLING_WINDOW_UNIT",
  COOLING_ZONED = "COOLING_ZONED",
}

export enum OdProtosHomeDataStore_HomeDetail_DiningArea {
  DINING_BREAKFAST_AREA = "DINING_BREAKFAST_AREA",
  DINING_BREAKFAST_BAR = "DINING_BREAKFAST_BAR",
  DINING_EAT_IN_KITCHEN = "DINING_EAT_IN_KITCHEN",
  DINING_FAMILY_COMBO = "DINING_FAMILY_COMBO",
  DINING_FORMAL = "DINING_FORMAL",
  DINING_FRONT_ROOM = "DINING_FRONT_ROOM",
  DINING_KITCHEN_COMBO = "DINING_KITCHEN_COMBO",
  DINING_LIVING_COMBO = "DINING_LIVING_COMBO",
  DINING_L_SHAPED = "DINING_L_SHAPED",
  DINING_NONE = "DINING_NONE",
  DINING_OTHER = "DINING_OTHER",
  DINING_UNKNOWN = "DINING_UNKNOWN",
}

/**
 * Fence structures and materials
 */
export enum OdProtosHomeDataStore_HomeDetail_FenceFeature {
  FENCE_ALUMINUM = "FENCE_ALUMINUM",
  FENCE_BACK_YARD = "FENCE_BACK_YARD",
  FENCE_BARBED_WIRE = "FENCE_BARBED_WIRE",
  FENCE_BLOCK = "FENCE_BLOCK",
  FENCE_BRICK = "FENCE_BRICK",
  FENCE_CHAIN_LINK = "FENCE_CHAIN_LINK",
  FENCE_CROSS_FENCED = "FENCE_CROSS_FENCED",
  FENCE_FRONT_YARD = "FENCE_FRONT_YARD",
  FENCE_FULLY_FENCED = "FENCE_FULLY_FENCED",
  FENCE_METAL = "FENCE_METAL",
  FENCE_NONE = "FENCE_NONE",
  FENCE_OTHER = "FENCE_OTHER",
  FENCE_PARTIAL = "FENCE_PARTIAL",
  FENCE_PRIVACY = "FENCE_PRIVACY",
  FENCE_STONE = "FENCE_STONE",
  FENCE_UNKNOWN = "FENCE_UNKNOWN",
  FENCE_VINYL = "FENCE_VINYL",
  FENCE_WIRE = "FENCE_WIRE",
  FENCE_WOOD = "FENCE_WOOD",
  FENCE_WROUGHT_IRON = "FENCE_WROUGHT_IRON",
}

export enum OdProtosHomeDataStore_HomeDetail_FireplaceFeature {
  FIREPLACE_BRICK = "FIREPLACE_BRICK",
  FIREPLACE_DECORATIVE = "FIREPLACE_DECORATIVE",
  FIREPLACE_ELECTRIC = "FIREPLACE_ELECTRIC",
  FIREPLACE_FIREPIT = "FIREPLACE_FIREPIT",
  FIREPLACE_FREE_STANDING = "FIREPLACE_FREE_STANDING",
  FIREPLACE_GAS = "FIREPLACE_GAS",
  FIREPLACE_GAS_LOG = "FIREPLACE_GAS_LOG",
  FIREPLACE_GAS_STARTER = "FIREPLACE_GAS_STARTER",
  FIREPLACE_INSERT = "FIREPLACE_INSERT",
  FIREPLACE_NONE = "FIREPLACE_NONE",
  FIREPLACE_OTHER = "FIREPLACE_OTHER",
  FIREPLACE_PELLET_STOVE = "FIREPLACE_PELLET_STOVE",
  FIREPLACE_TWO_WAY = "FIREPLACE_TWO_WAY",
  FIREPLACE_UNKNOWN = "FIREPLACE_UNKNOWN",
  FIREPLACE_WOOD = "FIREPLACE_WOOD",
  FIREPLACE_WOOD_BURNING_STOVE = "FIREPLACE_WOOD_BURNING_STOVE",
}

export enum OdProtosHomeDataStore_HomeDetail_FlooringMaterial {
  FLOORING_BAMBOO = "FLOORING_BAMBOO",
  FLOORING_BRICK = "FLOORING_BRICK",
  FLOORING_CARPET = "FLOORING_CARPET",
  FLOORING_CONCRETE = "FLOORING_CONCRETE",
  FLOORING_CORK = "FLOORING_CORK",
  FLOORING_ENGINEERED_HARDWOOD = "FLOORING_ENGINEERED_HARDWOOD",
  FLOORING_ENGINEERED_WOOD = "FLOORING_ENGINEERED_WOOD",
  FLOORING_GRANITE = "FLOORING_GRANITE",
  FLOORING_HARDWOOD = "FLOORING_HARDWOOD",
  FLOORING_LAMINATE = "FLOORING_LAMINATE",
  FLOORING_LINOLEUM = "FLOORING_LINOLEUM",
  FLOORING_LUXURY_VINYL_PLANK = "FLOORING_LUXURY_VINYL_PLANK",
  FLOORING_MARBLE = "FLOORING_MARBLE",
  FLOORING_OTHER = "FLOORING_OTHER",
  FLOORING_PAINTED = "FLOORING_PAINTED",
  FLOORING_PARQUET = "FLOORING_PARQUET",
  FLOORING_PAVERS = "FLOORING_PAVERS",
  FLOORING_SALTILLO_TILE = "FLOORING_SALTILLO_TILE",
  FLOORING_SLATE = "FLOORING_SLATE",
  FLOORING_STAMPED = "FLOORING_STAMPED",
  FLOORING_STONE = "FLOORING_STONE",
  FLOORING_TERRAZZO = "FLOORING_TERRAZZO",
  FLOORING_TILE = "FLOORING_TILE",
  FLOORING_TRAVERTINE = "FLOORING_TRAVERTINE",
  FLOORING_UNKNOWN = "FLOORING_UNKNOWN",
  FLOORING_VINYL = "FLOORING_VINYL",
  FLOORING_WOOD = "FLOORING_WOOD",
}

/**
 * Next Room Id: 20
 */
export enum OdProtosHomeDataStore_HomeDetail_HeatingFeature {
  HEATING_BASEBOARD = "HEATING_BASEBOARD",
  HEATING_BOILER = "HEATING_BOILER",
  HEATING_CEILING = "HEATING_CEILING",
  HEATING_CENTRAL = "HEATING_CENTRAL",
  HEATING_ELECTRIC = "HEATING_ELECTRIC",
  HEATING_FIREPLACE = "HEATING_FIREPLACE",
  HEATING_FLOOR_FURNACE = "HEATING_FLOOR_FURNACE",
  HEATING_GAS = "HEATING_GAS",
  HEATING_GEOTHERMAL = "HEATING_GEOTHERMAL",
  HEATING_HEAT_PUMP = "HEATING_HEAT_PUMP",
  HEATING_HIGH_EFFICIENCY = "HEATING_HIGH_EFFICIENCY",
  HEATING_HOT_WATER = "HEATING_HOT_WATER",
  HEATING_MINI_SPLIT = "HEATING_MINI_SPLIT",
  HEATING_NONE = "HEATING_NONE",
  HEATING_OIL = "HEATING_OIL",
  HEATING_OTHER = "HEATING_OTHER",
  HEATING_PROPANE = "HEATING_PROPANE",
  HEATING_RADIANT = "HEATING_RADIANT",
  HEATING_SOLAR = "HEATING_SOLAR",
  HEATING_STEAM = "HEATING_STEAM",
  HEATING_UNKNOWN = "HEATING_UNKNOWN",
  HEATING_WALL_FURNACE = "HEATING_WALL_FURNACE",
  HEATING_WALL_UNIT = "HEATING_WALL_UNIT",
  HEATING_WOOD = "HEATING_WOOD",
  HEATING_ZONED = "HEATING_ZONED",
}

export enum OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type {
  ATTORNEY = "ATTORNEY",
  MANAGING_AGENCY = "MANAGING_AGENCY",
  OWNERS_ASSOCIATION = "OWNERS_ASSOCIATION",
  UNKNOWN = "UNKNOWN",
}

/**
 * Type of association fee.
 */
export enum OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType {
  AMENTITY_FEE = "AMENTITY_FEE",
  BUILDING_MAINTAINENCE_FEE = "BUILDING_MAINTAINENCE_FEE",
  COMMUNITY_MASTER_HOME_OWNER_FEE = "COMMUNITY_MASTER_HOME_OWNER_FEE",
  FEE_CAPITAL_IMPROVEMENTS_FEE = "FEE_CAPITAL_IMPROVEMENTS_FEE",
  HOME_OWNER_ASSESSMENTS_FEE = "HOME_OWNER_ASSESSMENTS_FEE",
  HOME_OWNER_TRANSFER_FEE = "HOME_OWNER_TRANSFER_FEE",
  MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE = "MELLO_ROOS_COMMUNITY_FACILITIES_DISTRICT_FEE",
  POA_FEE = "POA_FEE",
  RECREATION_FEE = "RECREATION_FEE",
  RESORT_FEE = "RESORT_FEE",
  TENNIS_FEE = "TENNIS_FEE",
  UNKNOWN_HOA_FEE_TYPE = "UNKNOWN_HOA_FEE_TYPE",
}

/**
 * Owners association type.
 */
export enum OdProtosHomeDataStore_HomeDetail_Hoa_HoaType {
  CONDO_OWNER_ASSOCIATION = "CONDO_OWNER_ASSOCIATION",
  HOME_OWNER_ASSOCIATION = "HOME_OWNER_ASSOCIATION",
  LEGAL_AGENCY = "LEGAL_AGENCY",
  MANAGEMENT_AGENCY = "MANAGEMENT_AGENCY",
  PLANNED_UNIT_DEVELOPMENT = "PLANNED_UNIT_DEVELOPMENT",
  UNKNOWN_HOA_TYPE = "UNKNOWN_HOA_TYPE",
}

export enum OdProtosHomeDataStore_HomeDetail_HvacLocation {
  INDOOR = "INDOOR",
  OUTDOOR = "OUTDOOR",
  UNKNOWN_LOCATION = "UNKNOWN_LOCATION",
}

export enum OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType {
  ELECTRIC = "ELECTRIC",
  GAS = "GAS",
  UNKNOWN_ENERGY_TYPE = "UNKNOWN_ENERGY_TYPE",
}

export enum OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType {
  PACKAGED = "PACKAGED",
  SPLIT = "SPLIT",
  UNKNOWN_TYPE = "UNKNOWN_TYPE",
}

export enum OdProtosHomeDataStore_HomeDetail_HvacUnitType {
  AIR_HANDLING_UNIT = "AIR_HANDLING_UNIT",
  CONDENSER = "CONDENSER",
  FURNACE = "FURNACE",
  HEAT_PUMP = "HEAT_PUMP",
  UNKNOWN_UNIT_TYPE = "UNKNOWN_UNIT_TYPE",
}

export enum OdProtosHomeDataStore_HomeDetail_LaundryFeature {
  LAUNDRY_COMMUNITY_LAUNDRY = "LAUNDRY_COMMUNITY_LAUNDRY",
  LAUNDRY_DRYER_HOOKUP = "LAUNDRY_DRYER_HOOKUP",
  LAUNDRY_DRYER_INCLUDED = "LAUNDRY_DRYER_INCLUDED",
  LAUNDRY_NONE = "LAUNDRY_NONE",
  LAUNDRY_OTHER = "LAUNDRY_OTHER",
  LAUNDRY_UNKNOWN = "LAUNDRY_UNKNOWN",
  LAUNDRY_WASHER_HOOKUP = "LAUNDRY_WASHER_HOOKUP",
  LAUNDRY_WASHER_INCLUDED = "LAUNDRY_WASHER_INCLUDED",
}

export enum OdProtosHomeDataStore_HomeDetail_Location {
  LOCATION_BASEMENT = "LOCATION_BASEMENT",
  LOCATION_DEN = "LOCATION_DEN",
  LOCATION_DINING_ROOM = "LOCATION_DINING_ROOM",
  LOCATION_EXTERIOR = "LOCATION_EXTERIOR",
  LOCATION_FAMILY_ROOM = "LOCATION_FAMILY_ROOM",
  LOCATION_GARAGE = "LOCATION_GARAGE",
  LOCATION_GREAT_ROOM = "LOCATION_GREAT_ROOM",
  LOCATION_INTERIOR = "LOCATION_INTERIOR",
  LOCATION_KITCHEN = "LOCATION_KITCHEN",
  LOCATION_LAUNDRY_ROOM = "LOCATION_LAUNDRY_ROOM",
  LOCATION_LIVING_ROOM = "LOCATION_LIVING_ROOM",
  LOCATION_MASTER_BEDROOM = "LOCATION_MASTER_BEDROOM",
  LOCATION_UNKNOWN = "LOCATION_UNKNOWN",
  LOCATION_UPSTAIRS = "LOCATION_UPSTAIRS",
}

export enum OdProtosHomeDataStore_HomeDetail_OtherRoom {
  OTHER_ROOM_DEN_OFFICE = "OTHER_ROOM_DEN_OFFICE",
  OTHER_ROOM_EXERCISE_ROOM = "OTHER_ROOM_EXERCISE_ROOM",
  OTHER_ROOM_FAMILY_ROOM = "OTHER_ROOM_FAMILY_ROOM",
  OTHER_ROOM_FORMAL_DINING_ROOM = "OTHER_ROOM_FORMAL_DINING_ROOM",
  OTHER_ROOM_FORMAL_LIVING_ROOM_SEPARATE = "OTHER_ROOM_FORMAL_LIVING_ROOM_SEPARATE",
  OTHER_ROOM_FOYER = "OTHER_ROOM_FOYER",
  OTHER_ROOM_GAME_ROOM = "OTHER_ROOM_GAME_ROOM",
  OTHER_ROOM_GREAT_ROOM = "OTHER_ROOM_GREAT_ROOM",
  OTHER_ROOM_LAUNDRY_UTILITY_ROOM = "OTHER_ROOM_LAUNDRY_UTILITY_ROOM",
  OTHER_ROOM_LIBRARY = "OTHER_ROOM_LIBRARY",
  OTHER_ROOM_LOFT = "OTHER_ROOM_LOFT",
  OTHER_ROOM_MEDIA_ROOM = "OTHER_ROOM_MEDIA_ROOM",
  OTHER_ROOM_NONE = "OTHER_ROOM_NONE",
  OTHER_ROOM_OTHER = "OTHER_ROOM_OTHER",
  OTHER_ROOM_SCREENED_PORCH = "OTHER_ROOM_SCREENED_PORCH",
  OTHER_ROOM_SEP_GUEST_QUARTERS = "OTHER_ROOM_SEP_GUEST_QUARTERS",
  OTHER_ROOM_STORAGE = "OTHER_ROOM_STORAGE",
  OTHER_ROOM_SUN_ROOM = "OTHER_ROOM_SUN_ROOM",
  OTHER_ROOM_UNKNOWN = "OTHER_ROOM_UNKNOWN",
  OTHER_ROOM_WINE_CELLAR = "OTHER_ROOM_WINE_CELLAR",
  OTHER_ROOM_WORKSHOP = "OTHER_ROOM_WORKSHOP",
}

/**
 * Next Room Id: 45
 */
export enum OdProtosHomeDataStore_HomeDetail_ParkingFeature {
  PARKING_ALLEY_ACCESS = "PARKING_ALLEY_ACCESS",
  PARKING_ASSIGNED = "PARKING_ASSIGNED",
  PARKING_ATTACHED_GARAGE = "PARKING_ATTACHED_GARAGE",
  PARKING_ATTACHED_GARAGE_CABINETS = "PARKING_ATTACHED_GARAGE_CABINETS",
  PARKING_CARPORT = "PARKING_CARPORT",
  PARKING_CARPORT_ATTACHED = "PARKING_CARPORT_ATTACHED",
  PARKING_CARPORT_DETACHED = "PARKING_CARPORT_DETACHED",
  PARKING_CIRCULAR_DRIVEWAY = "PARKING_CIRCULAR_DRIVEWAY",
  PARKING_COMMON = "PARKING_COMMON",
  PARKING_COMMUNITY = "PARKING_COMMUNITY",
  PARKING_CONVERTED_GARAGE = "PARKING_CONVERTED_GARAGE",
  PARKING_COVERED = "PARKING_COVERED",
  PARKING_DETACHED_GARAGE = "PARKING_DETACHED_GARAGE",
  PARKING_DIRECT_GARAGE_ACCESS = "PARKING_DIRECT_GARAGE_ACCESS",
  PARKING_DRIVEWAY = "PARKING_DRIVEWAY",
  PARKING_ELECTRIC_CAR_CHARGING = "PARKING_ELECTRIC_CAR_CHARGING",
  PARKING_EXTENDED_LENGTH_GARAGE = "PARKING_EXTENDED_LENGTH_GARAGE",
  PARKING_FEE = "PARKING_FEE",
  PARKING_FRONT_ENTRY = "PARKING_FRONT_ENTRY",
  PARKING_GARAGE = "PARKING_GARAGE",
  PARKING_GARAGE_DOOR_OPENER = "PARKING_GARAGE_DOOR_OPENER",
  PARKING_GATED = "PARKING_GATED",
  PARKING_GOLF_CART = "PARKING_GOLF_CART",
  PARKING_HEATED_GARAGE = "PARKING_HEATED_GARAGE",
  PARKING_NONE = "PARKING_NONE",
  PARKING_OFFSITE = "PARKING_OFFSITE",
  PARKING_OFF_STREET = "PARKING_OFF_STREET",
  PARKING_OVERSIZED = "PARKING_OVERSIZED",
  PARKING_PAVED_DRIVEWAY = "PARKING_PAVED_DRIVEWAY",
  PARKING_PERMIT = "PARKING_PERMIT",
  PARKING_PULL_THROUGH = "PARKING_PULL_THROUGH",
  PARKING_REAR_ENTRY = "PARKING_REAR_ENTRY",
  PARKING_RV = "PARKING_RV",
  PARKING_RV_GARAGE = "PARKING_RV_GARAGE",
  PARKING_SHARED_DRIVEWAY = "PARKING_SHARED_DRIVEWAY",
  PARKING_SIDE_ENTRY = "PARKING_SIDE_ENTRY",
  PARKING_STORAGE = "PARKING_STORAGE",
  PARKING_STREET = "PARKING_STREET",
  PARKING_TANDEM = "PARKING_TANDEM",
  PARKING_TEMP_CONTROLLED = "PARKING_TEMP_CONTROLLED",
  PARKING_UNASSIGNED = "PARKING_UNASSIGNED",
  PARKING_UNKNOWN = "PARKING_UNKNOWN",
  PARKING_UNPAVED_DRIVEWAY = "PARKING_UNPAVED_DRIVEWAY",
  PARKING_VALET = "PARKING_VALET",
  PARKING_WORKSHOP = "PARKING_WORKSHOP",
}

/**
 * Slope direction relative to the home.
 */
export enum OdProtosHomeDataStore_HomeDetail_SlopeDirection {
  SLOPEDIR_DOWNHILL = "SLOPEDIR_DOWNHILL",
  SLOPEDIR_NONE = "SLOPEDIR_NONE",
  SLOPEDIR_UNKNOWN = "SLOPEDIR_UNKNOWN",
  SLOPEDIR_UPHILL = "SLOPEDIR_UPHILL",
}

export enum OdProtosHomeDataStore_HomeDetail_SlopeType {
  SLOPETYPE_NONE = "SLOPETYPE_NONE",
  SLOPETYPE_SLIGHT = "SLOPETYPE_SLIGHT",
  SLOPETYPE_SUBSTANTIAL = "SLOPETYPE_SUBSTANTIAL",
  SLOPETYPE_UNKNOWN = "SLOPETYPE_UNKNOWN",
}

/**
 * Source encodes where does this data comes from. This is needed so that we can have resolution strategies that
 * depend on where data came from. Source is a coarse grained category of where the data came from. E.g. all MLS
 * data is grouped into the MLS source.
 * 
 * If you plan to start writing to Home Data Store, please add yourself here and request a review from #data-infra.
 * Next Source ID: 30
 */
export enum OdProtosHomeDataStore_HomeDetail_Source {
  SOURCE_ADMIN_OVERRIDES = "SOURCE_ADMIN_OVERRIDES",
  SOURCE_ASSESSMENT = "SOURCE_ASSESSMENT",
  SOURCE_ATTOM_AND_CENSUS_MTRAC = "SOURCE_ATTOM_AND_CENSUS_MTRAC",
  SOURCE_ATTOM_HOA_DATA = "SOURCE_ATTOM_HOA_DATA",
  SOURCE_ATTOM_PARCELS = "SOURCE_ATTOM_PARCELS",
  SOURCE_BSI_PARCEL = "SOURCE_BSI_PARCEL",
  SOURCE_CORELOGIC_TAX_DATA = "SOURCE_CORELOGIC_TAX_DATA",
  SOURCE_FIELD_OPERATOR = "SOURCE_FIELD_OPERATOR",
  SOURCE_FIGURE_EIGHT = "SOURCE_FIGURE_EIGHT",
  SOURCE_FLOOR_PLAN = "SOURCE_FLOOR_PLAN",
  SOURCE_HOMEBUILDER = "SOURCE_HOMEBUILDER",
  SOURCE_LISTING_REMARKS = "SOURCE_LISTING_REMARKS",
  SOURCE_MAPONICS_PARCEL = "SOURCE_MAPONICS_PARCEL",
  SOURCE_MISSTATEMENT_RESOLUTION = "SOURCE_MISSTATEMENT_RESOLUTION",
  SOURCE_MLS = "SOURCE_MLS",
  SOURCE_MONSOON = "SOURCE_MONSOON",
  SOURCE_ODA_TOOLING = "SOURCE_ODA_TOOLING",
  SOURCE_OPENDOOR_BULK_LABELING = "SOURCE_OPENDOOR_BULK_LABELING",
  SOURCE_OPENDOOR_INTERNAL_EDIT = "SOURCE_OPENDOOR_INTERNAL_EDIT",
  SOURCE_OPENDOOR_INTERNAL_VALIDATION = "SOURCE_OPENDOOR_INTERNAL_VALIDATION",
  SOURCE_OSM = "SOURCE_OSM",
  SOURCE_PHOTO_LABELS = "SOURCE_PHOTO_LABELS",
  SOURCE_PROPCO_LISTING = "SOURCE_PROPCO_LISTING",
  SOURCE_REALTY_TRAC = "SOURCE_REALTY_TRAC",
  SOURCE_RESOLVED = "SOURCE_RESOLVED",
  SOURCE_SCRAPED_COUNTY_TAX_ASSESSOR = "SOURCE_SCRAPED_COUNTY_TAX_ASSESSOR",
  SOURCE_SELLER_INPUTS = "SOURCE_SELLER_INPUTS",
  SOURCE_SHERLOCK = "SOURCE_SHERLOCK",
  SOURCE_SHERLOCK_REPAIR_SCOPES = "SOURCE_SHERLOCK_REPAIR_SCOPES",
  SOURCE_UNKNOWN = "SOURCE_UNKNOWN",
  SOURCE_VAL_TOOL = "SOURCE_VAL_TOOL",
  SOURCE_VIRTUAL_ASSESSMENT = "SOURCE_VIRTUAL_ASSESSMENT",
  SOURCE_WOLLIZ = "SOURCE_WOLLIZ",
}

export enum OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType {
  ELECTRIC = "ELECTRIC",
  GAS = "GAS",
  UNKNOWN_ENERGY_TYPE = "UNKNOWN_ENERGY_TYPE",
}

export enum OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus {
  FULL = "FULL",
  NO_FENCE = "NO_FENCE",
  PARTIAL = "PARTIAL",
  UNSPECIFIED_STATUS = "UNSPECIFIED_STATUS",
}

/**
 * Next ID: 5
 */
export enum OdProtosListingsData_LwcProductView_Intent {
  DIRECT_SALE_VIA_LWC = "DIRECT_SALE_VIA_LWC",
  LISTING_VIA_LWC = "LISTING_VIA_LWC",
  NON_LWC = "NON_LWC",
  PENDING = "PENDING",
  UNSET = "UNSET",
}

/**
 * References the relationship between an Opendoor and the partner.
 * Next ID: 14
 */
export enum OdProtosPartnershipData_PartnershipType {
  AGENT_BROKERAGE = "AGENT_BROKERAGE",
  AGENT_TECH_INTEGRATION = "AGENT_TECH_INTEGRATION",
  CORPORATE_BENEFITS = "CORPORATE_BENEFITS",
  CREDIT_AND_DEBT = "CREDIT_AND_DEBT",
  HOME_BUILDER = "HOME_BUILDER",
  INDEPENDENT_DEVELOPER = "INDEPENDENT_DEVELOPER",
  LENDER = "LENDER",
  MARKETING = "MARKETING",
  MLS = "MLS",
  ONLINE_REAL_ESTATE = "ONLINE_REAL_ESTATE",
  REAL_ESTATE_AGENCY = "REAL_ESTATE_AGENCY",
  REIT = "REIT",
  TEST_PARTNER = "TEST_PARTNER",
  UNKNOWN = "UNKNOWN",
}

/**
 * A payable conversion event that we might pay partners for
 * Next ID: 7
 */
export enum OdProtosPartnershipData_PayableEvent {
  ACQ_CLOSED_WITH_RESALE = "ACQ_CLOSED_WITH_RESALE",
  AGENT_ACCESS_BONUS = "AGENT_ACCESS_BONUS",
  CLOSED_SALE = "CLOSED_SALE",
  OFFER_VIEWED = "OFFER_VIEWED",
  QUALIFIED_LEAD = "QUALIFIED_LEAD",
  RESALE_CLOSED_SALE = "RESALE_CLOSED_SALE",
  UNKNOWN_EVENT = "UNKNOWN_EVENT",
}

/**
 * Acceptance status of a referral invitation by the invitee
 * 
 * Next ID: 3
 */
export enum OdProtosPartnershipData_ReferralInvitationAcceptanceStatus {
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  PENDING = "PENDING",
}

/**
 * Exact attribution for this referral, i.e. referral type.
 * 
 * Next ID: 3
 */
export enum OdProtosPartnershipData_Referral_AttributionType {
  REFERRAL = "REFERRAL",
  REPRESENTATION = "REPRESENTATION",
  UNKNOWN_ATTRIBUTION = "UNKNOWN_ATTRIBUTION",
}

/**
 * Next ID: 6
 */
export enum OdProtosPartnershipData_Referral_SellerRelation {
  CLIENT = "CLIENT",
  POTENTIAL_CLIENT = "POTENTIAL_CLIENT",
  REFEREE = "REFEREE",
  REFERRAL_BY_INVITATION = "REFERRAL_BY_INVITATION",
  SELF = "SELF",
  UNKNOWN_RELATION = "UNKNOWN_RELATION",
}

/**
 * Next ID: 10
 */
export enum OdProtosPartnershipData_Referral_Source {
  ADMIN_OVERRIDE = "ADMIN_OVERRIDE",
  DETACHED_LEAD = "DETACHED_LEAD",
  PARTNER_API = "PARTNER_API",
  REFERRAL_DASHBOARD = "REFERRAL_DASHBOARD",
  REFERRAL_LINK = "REFERRAL_LINK",
  SCRIPT = "SCRIPT",
  SELLER_DISCLOSURES = "SELLER_DISCLOSURES",
  SELLER_FLOW = "SELLER_FLOW",
  TRACKING_KEYWORD = "TRACKING_KEYWORD",
  UNKNOWN = "UNKNOWN",
}

/**
 * Sell request states define the actions that can be performed on the sell request.
 * 
 * Terminal: Sell request cannot receive new buy offers and will not change state under normal
 *   circumstances.
 */
export enum OdProtosRealtyOdlsData_SellRequest_State {
  SELL_REQUEST_ACTIVE = "SELL_REQUEST_ACTIVE",
  SELL_REQUEST_CLOSED = "SELL_REQUEST_CLOSED",
  SELL_REQUEST_COMING_SOON = "SELL_REQUEST_COMING_SOON",
  SELL_REQUEST_EXPIRED = "SELL_REQUEST_EXPIRED",
  SELL_REQUEST_PRIVATELY_LISTED = "SELL_REQUEST_PRIVATELY_LISTED",
  SELL_REQUEST_SALE_PENDING = "SELL_REQUEST_SALE_PENDING",
  SELL_REQUEST_TEMP_OFF_MARKET = "SELL_REQUEST_TEMP_OFF_MARKET",
  SELL_REQUEST_UNKNOWN = "SELL_REQUEST_UNKNOWN",
  SELL_REQUEST_WITHDRAWN = "SELL_REQUEST_WITHDRAWN",
}

export enum OdProtosRubricV2Data_OptionBehavior_Action {
  NONE = "NONE",
  REQUIRE_COMMENT = "REQUIRE_COMMENT",
  REQUIRE_COMMENT_AND_PHOTO = "REQUIRE_COMMENT_AND_PHOTO",
  REQUIRE_COMMENT_AND_VIDEO = "REQUIRE_COMMENT_AND_VIDEO",
  REQUIRE_PHOTOS = "REQUIRE_PHOTOS",
  REQUIRE_VIDEOS = "REQUIRE_VIDEOS",
}

export enum OdProtosRubricV2Data_PromptGroupAddition_Condition {
  NONE = "NONE",
  ONE_PER_NUMBER = "ONE_PER_NUMBER",
}

export enum OdProtosRubricV2Data_Prompt_Type {
  FREEFORM = "FREEFORM",
  MULTIPLE_SELECT = "MULTIPLE_SELECT",
  PHOTO_INPUT = "PHOTO_INPUT",
  SINGLE_SELECT = "SINGLE_SELECT",
  UNKNOWN = "UNKNOWN",
  VIDEO_INPUT = "VIDEO_INPUT",
  YEAR_SELECT = "YEAR_SELECT",
}

export enum OdProtosRubricV2Data_TextValidation_AnswerTypeValidation {
  FLOAT = "FLOAT",
  INT = "INT",
  NONE = "NONE",
  YEAR = "YEAR",
}

/**
 * Denial reason if the customer was denied for a product.
 * Next ID: 74
 */
export enum OdProtosSellCommon_DenialReason {
  ACTIVE_OFFER = "ACTIVE_OFFER",
  ADDRESS = "ADDRESS",
  ADDRESS_OVERRIDE = "ADDRESS_OVERRIDE",
  AGENT_RELATION = "AGENT_RELATION",
  AGE_RESTRICTED_COMMUNITY = "AGE_RESTRICTED_COMMUNITY",
  AGE_RESTRICTED_SEASONAL = "AGE_RESTRICTED_SEASONAL",
  ASBESTOS_SIDING = "ASBESTOS_SIDING",
  BEFORE_1960 = "BEFORE_1960",
  BELOW_MARKET_RATE_OWNERSHIP = "BELOW_MARKET_RATE_OWNERSHIP",
  BUYER_UNAVAILABLE = "BUYER_UNAVAILABLE",
  CESSPOOL = "CESSPOOL",
  COVID_19 = "COVID_19",
  DENIED_FOR_OPENDOOR_DIRECT = "DENIED_FOR_OPENDOOR_DIRECT",
  DENIED_FOR_SELL_WITH_UPSIDE = "DENIED_FOR_SELL_WITH_UPSIDE",
  DEPENDENT_RULESET = "DEPENDENT_RULESET",
  DUPLICATE_LEAD = "DUPLICATE_LEAD",
  DWELLING_TYPE = "DWELLING_TYPE",
  EXPECTED_LGM = "EXPECTED_LGM",
  FEES_TOO_HIGH = "FEES_TOO_HIGH",
  FIRE_DAMAGE = "FIRE_DAMAGE",
  FLOOD_HISTORY = "FLOOD_HISTORY",
  FLOOD_ZONE = "FLOOD_ZONE",
  FOUNDATION = "FOUNDATION",
  GATED_COMMUNITY = "GATED_COMMUNITY",
  GUARD_GATED_COMMUNITY = "GUARD_GATED_COMMUNITY",
  INELIGIBLE_HOA = "INELIGIBLE_HOA",
  IN_CONTRACT_WITH_OPENDOOR = "IN_CONTRACT_WITH_OPENDOOR",
  LACK_OF_ADEQUATE_COMPS = "LACK_OF_ADEQUATE_COMPS",
  LEASED_SOLAR_PANELS = "LEASED_SOLAR_PANELS",
  LISTED_BY_OPENDOOR = "LISTED_BY_OPENDOOR",
  LIVESTOCK = "LIVESTOCK",
  LOT_SQ_FT = "LOT_SQ_FT",
  MLS_LISTING_STATUS = "MLS_LISTING_STATUS",
  MOBILE_MANUFACTURED_HOME = "MOBILE_MANUFACTURED_HOME",
  NON_BUYBOX_DWELLING_TYPE = "NON_BUYBOX_DWELLING_TYPE",
  NON_SERIOUS_SELLER = "NON_SERIOUS_SELLER",
  NOT_IN_AUTODENIAL_LISTING_EXP = "NOT_IN_AUTODENIAL_LISTING_EXP",
  NOT_IN_LWOD_PILOT = "NOT_IN_LWOD_PILOT",
  NOT_IN_SELL_WITH_UPSIDE_PILOT = "NOT_IN_SELL_WITH_UPSIDE_PILOT",
  NOT_IN_SIDE_BY_SIDE_EXP = "NOT_IN_SIDE_BY_SIDE_EXP",
  NO_DENIAL = "NO_DENIAL",
  OFFER_IN_PROGRESS = "OFFER_IN_PROGRESS",
  OFFER_OUTLIER = "OFFER_OUTLIER",
  OTHER_DENIAL = "OTHER_DENIAL",
  OTHER_DENIAL_DETAIL = "OTHER_DENIAL_DETAIL",
  OTHER_DENIAL_GENERAL = "OTHER_DENIAL_GENERAL",
  OTHER_HIGH_RISK = "OTHER_HIGH_RISK",
  OWNED_BY_OPENDOOR = "OWNED_BY_OPENDOOR",
  PARTNERSHIP = "PARTNERSHIP",
  POLYBUTYLENE_PIPING = "POLYBUTYLENE_PIPING",
  PREPARING_OFFER = "PREPARING_OFFER",
  PRIVATE_POOL = "PRIVATE_POOL",
  QUALIFIED_FOR_LWOD = "QUALIFIED_FOR_LWOD",
  QUALIFIED_FOR_OPENDOOR_DIRECT = "QUALIFIED_FOR_OPENDOOR_DIRECT",
  RESERVED_FOR_EXTERNAL_BROKER = "RESERVED_FOR_EXTERNAL_BROKER",
  SALE_TIMELINE = "SALE_TIMELINE",
  SELLER_TRIAGE = "SELLER_TRIAGE",
  SEPTIC = "SEPTIC",
  SHARED_ENTRANCE = "SHARED_ENTRANCE",
  SHARED_LOT = "SHARED_LOT",
  TENANT_OCCUPIED = "TENANT_OCCUPIED",
  TRADE_IN = "TRADE_IN",
  UNABLE_TO_VALUE = "UNABLE_TO_VALUE",
  UNDERGROUND_OIL_TANK = "UNDERGROUND_OIL_TANK",
  UNIQUE_OWNERSHIP_STRUCTURE = "UNIQUE_OWNERSHIP_STRUCTURE",
  UNPERMITTED_ADDITION = "UNPERMITTED_ADDITION",
  VALUATION_TOO_HIGH = "VALUATION_TOO_HIGH",
  VALUATION_TOO_LOW = "VALUATION_TOO_LOW",
  VALUATION_TOO_LOW_LISTED = "VALUATION_TOO_LOW_LISTED",
  WELL_WATER = "WELL_WATER",
  WORKING_WITH_HOMEBUILDER = "WORKING_WITH_HOMEBUILDER",
  YEAR_BUILT = "YEAR_BUILT",
}

/**
 * A Product that we can offer to the seller.
 * Next ID: 11
 */
export enum OdProtosSellCommon_Product {
  AGENT_REFERRAL = "AGENT_REFERRAL",
  BUY_WITH_OPENDOOR = "BUY_WITH_OPENDOOR",
  EXTERNAL_LISTING_AGENT = "EXTERNAL_LISTING_AGENT",
  LIST_WITH_CERTAINTY = "LIST_WITH_CERTAINTY",
  LIST_WITH_OPENDOOR = "LIST_WITH_OPENDOOR",
  OPENDOOR_BACKED_OFFERS = "OPENDOOR_BACKED_OFFERS",
  OPENDOOR_DIRECT = "OPENDOOR_DIRECT",
  REIT = "REIT",
  SELL_WITH_EXCLUSIVES = "SELL_WITH_EXCLUSIVES",
  SELL_WITH_UPSIDE = "SELL_WITH_UPSIDE",
  UNKNOWN_PRODUCT = "UNKNOWN_PRODUCT",
}

/**
 * The timeline the seller has when looking to sell their home.
 * Next ID: 6
 */
export enum OdProtosSellCommon_Timeline {
  ASAP = "ASAP",
  JUST_BROWSING = "JUST_BROWSING",
  UNKNOWN_TIMELINE = "UNKNOWN_TIMELINE",
  WEEKS_2_4 = "WEEKS_2_4",
  WEEKS_4_6 = "WEEKS_4_6",
  WEEKS_6_PLUS = "WEEKS_6_PLUS",
}

/**
 * The channel the seller came in from, used to determine the overall experience
 * the seller will go through.
 * Next ID: 19
 */
export enum OdProtosSellReceptionData_SellerInput_Channel {
  AGENT_REQUEST = "AGENT_REQUEST",
  AGENT_REQUEST_LISTED = "AGENT_REQUEST_LISTED",
  APP = "APP",
  BUY_SELL_FLOW = "BUY_SELL_FLOW",
  CAKE_LANDING_PAGE = "CAKE_LANDING_PAGE",
  DEFAULT = "DEFAULT",
  EMAIL_PROSPECTING = "EMAIL_PROSPECTING",
  EXCLUSIVE_OFFERS = "EXCLUSIVE_OFFERS",
  FLYWHEEL = "FLYWHEEL",
  HOME_RESERVE = "HOME_RESERVE",
  HOME_VALUE = "HOME_VALUE",
  OPENDOOR_BACKED_OFFER = "OPENDOOR_BACKED_OFFER",
  OUTBOUND_OFFERS_LISTED = "OUTBOUND_OFFERS_LISTED",
  PARTNER_API = "PARTNER_API",
  REIT_BULK_REQUEST = "REIT_BULK_REQUEST",
  REIT_BULK_REQUEST_LISTED = "REIT_BULK_REQUEST_LISTED",
  SELLER_REQUEST_LISTED = "SELLER_REQUEST_LISTED",
  TRADE_IN = "TRADE_IN",
  UNSET_CHANNEL = "UNSET_CHANNEL",
}

export enum OdProtosSellSellerData_Lead_Source_Type {
  PARTNERSHIP = "PARTNERSHIP",
  RECEPTION = "RECEPTION",
  UNKNOWN_TYPE = "UNKNOWN_TYPE",
}

export enum OdProtosValidataData_ScanEligibility {
  SCAN_ELIGIBILITY_POST_ACQUISITION = "SCAN_ELIGIBILITY_POST_ACQUISITION",
  SCAN_ELIGIBILITY_PRE_ACQUISITION = "SCAN_ELIGIBILITY_PRE_ACQUISITION",
  SCAN_ELIGIBILITY_UNKNOWN = "SCAN_ELIGIBILITY_UNKNOWN",
}

/**
 * Sell Direct offer price types
 * Next ID: 2
 */
export enum OdProtosWebDataSellDirect_PriceType {
  CLOSE_OF_ESCROW_FEE = "CLOSE_OF_ESCROW_FEE",
  REQUESTED_CLOSE_OF_ESCROW_FEE = "REQUESTED_CLOSE_OF_ESCROW_FEE",
  UNKNOWN_PRICE_TYPE = "UNKNOWN_PRICE_TYPE",
}

/**
 * Next ID: 174
 */
export enum OdProtosWebData_Document_Type {
  ABAD = "ABAD",
  ACQ_AGENT_REFERRAL_FORM = "ACQ_AGENT_REFERRAL_FORM",
  ACQ_DEED = "ACQ_DEED",
  ACQ_EMR = "ACQ_EMR",
  ACQ_FINAL_SETTLEMENT_STATEMENT = "ACQ_FINAL_SETTLEMENT_STATEMENT",
  ACQ_HOA_DEMAND = "ACQ_HOA_DEMAND",
  ACQ_HOA_GOVERNING_DOCS = "ACQ_HOA_GOVERNING_DOCS",
  ACQ_HOA_RECEIPT = "ACQ_HOA_RECEIPT",
  ACQ_LAND_SURVEY = "ACQ_LAND_SURVEY",
  ACQ_NATURAL_HAZARD_DISCLOSURE = "ACQ_NATURAL_HAZARD_DISCLOSURE",
  ACQ_OUTBOUND_ADDENDUM = "ACQ_OUTBOUND_ADDENDUM",
  ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = "ACQ_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT",
  ACQ_TAX_CERTIFICATE = "ACQ_TAX_CERTIFICATE",
  ACQ_TITLE_COMMITMENT = "ACQ_TITLE_COMMITMENT",
  ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = "ACQ_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT",
  ADDENDUM = "ADDENDUM",
  AGENT_REFERRAL_W9 = "AGENT_REFERRAL_W9",
  AMENDMENT = "AMENDMENT",
  APPRAISAL_REPORT = "APPRAISAL_REPORT",
  AVID_BUYER = "AVID_BUYER",
  AVID_SELLER = "AVID_SELLER",
  BINDING_COUNTER_OFFER = "BINDING_COUNTER_OFFER",
  BINSR = "BINSR",
  BRN_CREDIT_ADDENDUM = "BRN_CREDIT_ADDENDUM",
  BRN_RESPONSE = "BRN_RESPONSE",
  BROKER_PRICE_OPINION = "BROKER_PRICE_OPINION",
  BUYER_CLOSING_DOCS = "BUYER_CLOSING_DOCS",
  CANCEL_BINSR = "CANCEL_BINSR",
  CCR = "CCR",
  CHANGE_CLOSE_OF_ESCROW_ADDENDUM = "CHANGE_CLOSE_OF_ESCROW_ADDENDUM",
  CHECKLIST_HOA_SOU = "CHECKLIST_HOA_SOU",
  CIC_RECEIPT = "CIC_RECEIPT",
  CLOSING_STATEMENT_FOR_APPROVAL = "CLOSING_STATEMENT_FOR_APPROVAL",
  CLUE = "CLUE",
  COMBINED = "COMBINED",
  COMBINED_FILE = "COMBINED_FILE",
  COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = "COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM",
  COMMISSION_INSTRUCTIONS = "COMMISSION_INSTRUCTIONS",
  CONFIRMATION_OF_NO_HOA = "CONFIRMATION_OF_NO_HOA",
  CONTINGENCY = "CONTINGENCY",
  CONTINGENCY_REMOVAL = "CONTINGENCY_REMOVAL",
  COUNTER = "COUNTER",
  DEED = "DEED",
  EOI = "EOI",
  FINALIZE_BINSR = "FINALIZE_BINSR",
  FINAL_REPAIR_ASK = "FINAL_REPAIR_ASK",
  FINAL_SETTLEMENT_STATEMENT = "FINAL_SETTLEMENT_STATEMENT",
  FIRPTA = "FIRPTA",
  HOA = "HOA",
  HOA_ADDENDUM = "HOA_ADDENDUM",
  HOA_BUYER_APPROVAL = "HOA_BUYER_APPROVAL",
  HOA_CCRS = "HOA_CCRS",
  HOA_CCR_AMENDMENT = "HOA_CCR_AMENDMENT",
  HOA_DEMAND = "HOA_DEMAND",
  HOA_DEMAND_SUB = "HOA_DEMAND_SUB",
  HOA_ESTOPPEL_LETTER_UPDATED = "HOA_ESTOPPEL_LETTER_UPDATED",
  HOA_PACKAGE = "HOA_PACKAGE",
  HOA_STATUS_LETTER = "HOA_STATUS_LETTER",
  HOA_VIOLATION_RESOLUTION = "HOA_VIOLATION_RESOLUTION",
  HOME_CONDITION_BRANDED = "HOME_CONDITION_BRANDED",
  HOME_CONDITION_UNBRANDED = "HOME_CONDITION_UNBRANDED",
  HOME_WARRANTY_INVOICE = "HOME_WARRANTY_INVOICE",
  INITIAL_BINSR_REQUEST = "INITIAL_BINSR_REQUEST",
  INITIAL_REPAIR_ASK = "INITIAL_REPAIR_ASK",
  INSPECTION_REPORT_ELECTRICAL = "INSPECTION_REPORT_ELECTRICAL",
  INSPECTION_REPORT_FOUNDATION = "INSPECTION_REPORT_FOUNDATION",
  INSPECTION_REPORT_GENERAL = "INSPECTION_REPORT_GENERAL",
  INSPECTION_REPORT_HVAC = "INSPECTION_REPORT_HVAC",
  INSPECTION_REPORT_OTHER = "INSPECTION_REPORT_OTHER",
  INSPECTION_REPORT_PLUMBING = "INSPECTION_REPORT_PLUMBING",
  INSPECTION_REPORT_POOL = "INSPECTION_REPORT_POOL",
  INSPECTION_REPORT_ROOF = "INSPECTION_REPORT_ROOF",
  INSPECTION_REPORT_SHERLOCK = "INSPECTION_REPORT_SHERLOCK",
  INSPECTION_REPORT_TERMITE = "INSPECTION_REPORT_TERMITE",
  INSURANCE_CLAIM = "INSURANCE_CLAIM",
  INVOICE = "INVOICE",
  LAND_SURVEY = "LAND_SURVEY",
  LATE_CHECKOUT_ADDENDUM = "LATE_CHECKOUT_ADDENDUM",
  LBP_ADDENDUM = "LBP_ADDENDUM",
  LEASED_FIXTURES = "LEASED_FIXTURES",
  LIEN_SEARCH = "LIEN_SEARCH",
  LIGHTWEIGHT_PURCHASE_AGREEMENT = "LIGHTWEIGHT_PURCHASE_AGREEMENT",
  LISTING_DISCLOSURE = "LISTING_DISCLOSURE",
  LISTING_PACKET = "LISTING_PACKET",
  LOSS_HISTORY_REPORT = "LOSS_HISTORY_REPORT",
  LWOD_OFFER_REVIEW = "LWOD_OFFER_REVIEW",
  MARKET_CONDITIONS_ADVISORY = "MARKET_CONDITIONS_ADVISORY",
  MINERAL_OIL_GAS = "MINERAL_OIL_GAS",
  MISC = "MISC",
  NAME_CHANGE = "NAME_CHANGE",
  NON_BINDING_COUNTER_OFFER = "NON_BINDING_COUNTER_OFFER",
  NON_REQUIRED_DOCS = "NON_REQUIRED_DOCS",
  OD_ADDENDUM = "OD_ADDENDUM",
  OD_GUARANTEE = "OD_GUARANTEE",
  OD_SERVICES_ADDENDUM = "OD_SERVICES_ADDENDUM",
  OUTBOUND_PURCHASE_AGREEMENT = "OUTBOUND_PURCHASE_AGREEMENT",
  OWNERS_POLICY = "OWNERS_POLICY",
  O_AND_E_RECEIPT = "O_AND_E_RECEIPT",
  PREPARED_DEED = "PREPARED_DEED",
  PREQUAL = "PREQUAL",
  PROOF_OF_FUNDS = "PROOF_OF_FUNDS",
  PROPERTY_DISCLOSURE = "PROPERTY_DISCLOSURE",
  PROPOSED_AMENDMENT = "PROPOSED_AMENDMENT",
  PTL = "PTL",
  PURCHASE_AGREEMENT = "PURCHASE_AGREEMENT",
  PURCHASE_AGREEMENT_TERMINATION = "PURCHASE_AGREEMENT_TERMINATION",
  REALTOR_DISCLOSURE = "REALTOR_DISCLOSURE",
  REIT_RESALE_PURCHASE_CONTRACT = "REIT_RESALE_PURCHASE_CONTRACT",
  REJECTED_SETTLEMENT_STATEMENT = "REJECTED_SETTLEMENT_STATEMENT",
  RENOVATION_PROPOSAL = "RENOVATION_PROPOSAL",
  REPAIR_ADDENDUM = "REPAIR_ADDENDUM",
  RESALE_ADDENDUM = "RESALE_ADDENDUM",
  RESALE_EMR = "RESALE_EMR",
  RESALE_FINAL_SETTLEMENT_STATEMENT = "RESALE_FINAL_SETTLEMENT_STATEMENT",
  RESALE_SIGNED_SELLER_CLOSING_DOCS = "RESALE_SIGNED_SELLER_CLOSING_DOCS",
  RS_ADDENDUM = "RS_ADDENDUM",
  RS_ADDENDUM_CONTINGENCY = "RS_ADDENDUM_CONTINGENCY",
  RS_ADDENDUM_HOA = "RS_ADDENDUM_HOA",
  RS_ADDENDUM_LBP = "RS_ADDENDUM_LBP",
  RS_ADDENDUM_MINERAL_OIL_GAS = "RS_ADDENDUM_MINERAL_OIL_GAS",
  RS_ADDENDUM_TPF = "RS_ADDENDUM_TPF",
  RS_AGENT_REFERRAL_FORM = "RS_AGENT_REFERRAL_FORM",
  RS_AMENDMENT = "RS_AMENDMENT",
  RS_BRN_FINAL = "RS_BRN_FINAL",
  RS_BRN_FINAL_CREDIT_ADDENDUM = "RS_BRN_FINAL_CREDIT_ADDENDUM",
  RS_BRN_INITIAL = "RS_BRN_INITIAL",
  RS_BUYER_CLOSING_DOCS = "RS_BUYER_CLOSING_DOCS",
  RS_BUYER_INSPECTION_FOUNDATION = "RS_BUYER_INSPECTION_FOUNDATION",
  RS_BUYER_INSPECTION_GENERAL = "RS_BUYER_INSPECTION_GENERAL",
  RS_BUYER_INSPECTION_HVAC = "RS_BUYER_INSPECTION_HVAC",
  RS_BUYER_INSPECTION_OTHER = "RS_BUYER_INSPECTION_OTHER",
  RS_BUYER_INSPECTION_ROOF = "RS_BUYER_INSPECTION_ROOF",
  RS_BUYER_INSPECTION_TERMITE = "RS_BUYER_INSPECTION_TERMITE",
  RS_CANCEL_DOCUMENT = "RS_CANCEL_DOCUMENT",
  RS_CIC_RECEIPT = "RS_CIC_RECEIPT",
  RS_COUNTER = "RS_COUNTER",
  RS_CURE_NOTICE = "RS_CURE_NOTICE",
  RS_DEED = "RS_DEED",
  RS_FHA_LOAN_AMENDATORY = "RS_FHA_LOAN_AMENDATORY",
  RS_FINAL_SETTLEMENT_STATEMENT = "RS_FINAL_SETTLEMENT_STATEMENT",
  RS_HOA_DOCS = "RS_HOA_DOCS",
  RS_HOA_RECEIPT = "RS_HOA_RECEIPT",
  RS_HOME_WARRANTY_INVOICE = "RS_HOME_WARRANTY_INVOICE",
  RS_LAND_SURVEY = "RS_LAND_SURVEY",
  RS_LOAN_STATUS_UPDATE = "RS_LOAN_STATUS_UPDATE",
  RS_NATURAL_HAZARD_DISCLOSURE = "RS_NATURAL_HAZARD_DISCLOSURE",
  RS_PRE_CLOSE_WALKTHROUGH = "RS_PRE_CLOSE_WALKTHROUGH",
  RS_REALTOR_DISCLOSURE_AGENCY = "RS_REALTOR_DISCLOSURE_AGENCY",
  RS_RECEIPT_EM = "RS_RECEIPT_EM",
  RS_RECEIPT_OTHER = "RS_RECEIPT_OTHER",
  RS_SELLER_SIGNED_CLOSING_DOCS = "RS_SELLER_SIGNED_CLOSING_DOCS",
  RS_SURVEY = "RS_SURVEY",
  RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT = "RS_T47_RESIDENTIAL_REAL_PROPERTY_AFFIDAVIT",
  RS_TAX_CERTIFICATE = "RS_TAX_CERTIFICATE",
  RS_TITLE_COMMITMENT = "RS_TITLE_COMMITMENT",
  RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT = "RS_UNSIGNED_DRAFT_SETTLEMENT_STATEMENT",
  RS_USER_MISC = "RS_USER_MISC",
  RS_VA_LOAN_AMENDATORY = "RS_VA_LOAN_AMENDATORY",
  RS_W9 = "RS_W9",
  SELLER_DISCLOSURES = "SELLER_DISCLOSURES",
  SHERLOCK_ASSESSMENT_REPORT = "SHERLOCK_ASSESSMENT_REPORT",
  SOLAR_INFORMATION = "SOLAR_INFORMATION",
  SOLAR_MISC = "SOLAR_MISC",
  SOLAR_PAYOFF = "SOLAR_PAYOFF",
  SOLAR_TRANSFER_AGREEMENT = "SOLAR_TRANSFER_AGREEMENT",
  SPDS = "SPDS",
  STATE_OR_COUNTY_DISCLOSURES = "STATE_OR_COUNTY_DISCLOSURES",
  TAX_CERTIFICATE = "TAX_CERTIFICATE",
  THIRD_PARTY_ADDENDUM = "THIRD_PARTY_ADDENDUM",
  TITLE_COMMITMENT = "TITLE_COMMITMENT",
  TITLE_COMPANY_CHANGE = "TITLE_COMPANY_CHANGE",
  TITLE_DISCLOSURE = "TITLE_DISCLOSURE",
  UCC_TERMINATION = "UCC_TERMINATION",
  UNKNOWN_DOCUMENT = "UNKNOWN_DOCUMENT",
}

/**
 * Next ID: 3
 */
export enum OdProtosWebData_ExperimentsEnum {
  GUARANTEE_AT_PRELIM_OFFER = "GUARANTEE_AT_PRELIM_OFFER",
  NO_VIRTUAL_ASSESSMENT = "NO_VIRTUAL_ASSESSMENT",
  UNKNOWN_EXPERIMENT = "UNKNOWN_EXPERIMENT",
}

/**
 * Next ID: 2
 */
export enum OdProtosWebData_FeatureFlagEnum {
  UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING = "UNEXPIRE_OFFER_WITH_VALID_UNDERWRITING",
  UNKNOWN_FEATURE_FLAG = "UNKNOWN_FEATURE_FLAG",
}

export enum OdProtosWebData_InspectionStep_InspectionStepState {
  COMPLETED = "COMPLETED",
  NOT_SCHEDULED = "NOT_SCHEDULED",
  SCHEDULED = "SCHEDULED",
  UNKNOWN_STATE = "UNKNOWN_STATE",
}

export enum OdProtosWebData_InspectionStep_InspectionType {
  EA = "EA",
  HA = "HA",
  UNKNOWN_INSPECTION_TYPE = "UNKNOWN_INSPECTION_TYPE",
}

export enum OdProtosWebData_ListingOfferDetails_FinancingStatus {
  CASH = "CASH",
  CONVENTIONAL = "CONVENTIONAL",
  DONT_KNOW = "DONT_KNOW",
  FHA_LOAN = "FHA_LOAN",
  TX_VA_LOAN = "TX_VA_LOAN",
  USDA_LOAN = "USDA_LOAN",
  VA_LOAN = "VA_LOAN",
}

/**
 * Next ID: 5
 */
export enum OdProtosWebData_ORVAState {
  ORVA_ATTEMPTED = "ORVA_ATTEMPTED",
  ORVA_COMPLETED = "ORVA_COMPLETED",
  ORVA_EXPIRED = "ORVA_EXPIRED",
  ORVA_NOT_STARTED = "ORVA_NOT_STARTED",
  ORVA_SCHEDULED = "ORVA_SCHEDULED",
}

export enum OdProtosWebData_ORVAStep_ORVAState {
  COMPLETED = "COMPLETED",
  NOT_SCHEDULED = "NOT_SCHEDULED",
  SCHEDULED = "SCHEDULED",
  UNKNOWN_STATE = "UNKNOWN_STATE",
}

export enum OdProtosWebData_ORVAStep_ORVASubtype {
  DEFAULT = "DEFAULT",
  UNKNOWN_ORVA_SUBTYPE = "UNKNOWN_ORVA_SUBTYPE",
  WITH_EVA = "WITH_EVA",
}

/**
 * Next ID: 5
 */
export enum OdProtosWebData_OccupancyAtVa {
  LIVE_FAR_AWAY = "LIVE_FAR_AWAY",
  OTHER_OCCUPANCY = "OTHER_OCCUPANCY",
  OWNER_OCCUPIED = "OWNER_OCCUPIED",
  TENANT_OCCUPIED = "TENANT_OCCUPIED",
  UNKNOWN_OCCUPANCY = "UNKNOWN_OCCUPANCY",
}

/**
 * Next ID: 16
 */
export enum OdProtosWebData_Offer_State {
  ACCEPTED = "ACCEPTED",
  ACCEPTED_OFFER = "ACCEPTED_OFFER",
  CLOSED = "CLOSED",
  CONTINGENCY_RELEASED = "CONTINGENCY_RELEASED",
  DRAFT = "DRAFT",
  EXPIRED = "EXPIRED",
  FINAL_OFFER_UNRELEASED = "FINAL_OFFER_UNRELEASED",
  IN_CONTRACT = "IN_CONTRACT",
  READY_TO_SEND = "READY_TO_SEND",
  REQUESTED_TO_LIST = "REQUESTED_TO_LIST",
  SEND_IN_PROGRESS = "SEND_IN_PROGRESS",
  SENT = "SENT",
  UNKNOWN = "UNKNOWN",
  VIEWING = "VIEWING",
  WAITING_FOR_LIST_WITH_CERTAINTY = "WAITING_FOR_LIST_WITH_CERTAINTY",
  WAITING_FOR_OTHER_OFFERS = "WAITING_FOR_OTHER_OFFERS",
  WITHDRAWN = "WITHDRAWN",
}

/**
 * List of known participant roles in web, from web/app/models/concerns/participant_roles.rb
 */
export enum OdProtosWebData_ParticipantRole {
  ACQ_AE = "ACQ_AE",
  ACQ_AGENT = "ACQ_AGENT",
  ACQ_CX = "ACQ_CX",
  ACQ_EM = "ACQ_EM",
  ACQ_SDR = "ACQ_SDR",
  ACQ_TC = "ACQ_TC",
  BROKER = "BROKER",
  CONSISTENT_VALUATIONS = "CONSISTENT_VALUATIONS",
  ESTIMATOR = "ESTIMATOR",
  FINANCE_TC = "FINANCE_TC",
  HOLDING_SUPPORT = "HOLDING_SUPPORT",
  HPM = "HPM",
  INITIATOR = "INITIATOR",
  OUTLIER_VALUATIONS = "OUTLIER_VALUATIONS",
  PORTFOLIO_MANAGER = "PORTFOLIO_MANAGER",
  RENO_MANAGER = "RENO_MANAGER",
  RESALE_ACX = "RESALE_ACX",
  RESALE_AGENT = "RESALE_AGENT",
  RESALE_CC = "RESALE_CC",
  RESALE_CX_SALES = "RESALE_CX_SALES",
  RESALE_CX_SALES_ASSOCIATE = "RESALE_CX_SALES_ASSOCIATE",
  RESALE_CX_VISITOR = "RESALE_CX_VISITOR",
  RESALE_TC = "RESALE_TC",
  ROLE_UNKNOWN = "ROLE_UNKNOWN",
  SECURITY_SUPPORT = "SECURITY_SUPPORT",
  SELLER_PARTICIPANT = "SELLER_PARTICIPANT",
  SIGNATORY = "SIGNATORY",
  SOFT_RESALE_ACX = "SOFT_RESALE_ACX",
  SYSTEM = "SYSTEM",
  TC_SUPPORT = "TC_SUPPORT",
  UNDERWRITER = "UNDERWRITER",
  UTILITY_SUPPORT = "UTILITY_SUPPORT",
  VALUATIONS = "VALUATIONS",
  VENDOR_DRIVER = "VENDOR_DRIVER",
}

/**
 * The enum here should match with the following defined in Web
 * https: // github.com/opendoor-labs/web/blob/4ec863aaf36a82b0c9df10b4de196020d142c7c6/app/models/virtual_assessment_recording.rb#L8
 * Next ID: 10
 */
export enum OdProtosWebData_RecordedFeature {
  BACKYARD = "BACKYARD",
  FRONTYARD = "FRONTYARD",
  INTERIOR = "INTERIOR",
  KITCHEN = "KITCHEN",
  LIVING_ROOM = "LIVING_ROOM",
  MASTER_BEDROOM_AND_BATHROOM = "MASTER_BEDROOM_AND_BATHROOM",
  SELLER_DISCLOSURE_DOCUMENT = "SELLER_DISCLOSURE_DOCUMENT",
  UNKNOWN_RECORDED_FEATURE = "UNKNOWN_RECORDED_FEATURE",
  UTILITIES = "UTILITIES",
  WHOLE_HOME = "WHOLE_HOME",
}

/**
 * Next ID: 3
 */
export enum OdProtosWebData_SSVAState {
  SSVA_COMPLETED = "SSVA_COMPLETED",
  SSVA_IN_PROGRESS = "SSVA_IN_PROGRESS",
  SSVA_NOT_STARTED = "SSVA_NOT_STARTED",
}

export enum OdProtosWebData_SSVAStep_SSVAState {
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  NOT_STARTED = "NOT_STARTED",
  UNKNOWN_STATE = "UNKNOWN_STATE",
}

export enum OdProtosWebData_SSVAStep_SSVASubtype {
  DEFAULT = "DEFAULT",
  DISCLOSURE = "DISCLOSURE",
  UNKNOWN_SSVA_SUBTYPE = "UNKNOWN_SSVA_SUBTYPE",
  WHOLE_HOME = "WHOLE_HOME",
}

/**
 * Next ID: 6
 */
export enum OdProtosWebData_Underwriting_State {
  APPROVED = "APPROVED",
  COMPLETED = "COMPLETED",
  DRAFT = "DRAFT",
  ESCALATED = "ESCALATED",
  UNKNOWN = "UNKNOWN",
  WALKED = "WALKED",
}

export enum OdProtosWebData_VirtualAssessmentStep_VirtualAssessmentType {
  ORVA = "ORVA",
  SSVA = "SSVA",
  UNKNOWN_VIRTUAL_ASSESSMENT_TYPE = "UNKNOWN_VIRTUAL_ASSESSMENT_TYPE",
  VA = "VA",
}

export enum OdProtosWebServicesBuyDirect_Responses_NotifyAepOfContingentBuyer_Status {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum OfferSnapshotSource {
  BUY_DIRECT = "BUY_DIRECT",
  BUY_WITH_OPENDOOR = "BUY_WITH_OPENDOOR",
}

export enum OfferSnapshotState {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
  DRAFT = "DRAFT",
  IN_CONTRACT = "IN_CONTRACT",
  IN_REVIEW = "IN_REVIEW",
  REJECTED = "REJECTED",
  UNKNOWN = "UNKNOWN",
}

export enum ResaleContractDetailsLoanType {
  CONVENTIONAL = "CONVENTIONAL",
  FHA = "FHA",
  OTHER = "OTHER",
  VA = "VA",
}

export enum SprinklerTimer {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
  UNKNOWN = "UNKNOWN",
}

export enum TaskType {
  HOA_FEES = "HOA_FEES",
  HVAC_ROOF_INFO = "HVAC_ROOF_INFO",
  LATE_CHECKOUT = "LATE_CHECKOUT",
  OTHER_HOME_INFO = "OTHER_HOME_INFO",
  SERVICE_ACCOUNTS = "SERVICE_ACCOUNTS",
  SET_CLOSE_DATE = "SET_CLOSE_DATE",
  SET_SIGNATORIES = "SET_SIGNATORIES",
  SIGN_CHANGE_CLOSE_OF_ESCROW_ADDENDUM = "SIGN_CHANGE_CLOSE_OF_ESCROW_ADDENDUM",
  SIGN_COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM = "SIGN_COMBINED_PURCHASE_AGREEMENT_AND_REPAIR_ADDENDUM",
  SIGN_FORM_ADDENDUM = "SIGN_FORM_ADDENDUM",
  SIGN_LATE_CHECKOUT_ADDENDUM = "SIGN_LATE_CHECKOUT_ADDENDUM",
  UNKNOWN = "UNKNOWN",
}

/**
 * This enum captures the comprehensive states that should be presented to a customer.
 * The value can be determined by a combination of different values in the backend across
 * systems.
 */
export enum TransactionState {
  BUY_DIRECT_AWAITING_COUNTERSIGNATURE = "BUY_DIRECT_AWAITING_COUNTERSIGNATURE",
  BUY_DIRECT_BACKUP = "BUY_DIRECT_BACKUP",
  BUY_DIRECT_IN_CONTRACT = "BUY_DIRECT_IN_CONTRACT",
  BUY_DIRECT_UNSIGNED_CONTRACT = "BUY_DIRECT_UNSIGNED_CONTRACT",
  CANCELED_OFFER = "CANCELED_OFFER",
  CLOSE = "CLOSE",
  REJECTED = "REJECTED",
}

/**
 * This enum is used to distinguish between Buy Direct transactions and traditional
 * Buy with Opendoor 3P transactions
 */
export enum TransactionType {
  BUY_DIRECT = "BUY_DIRECT",
  BUY_WITH_OPENDOOR = "BUY_WITH_OPENDOOR",
}

/**
 * The different service accounts (not an exhaustive list)
 */
export enum WebFlipUtilityKind {
  ELECTRICITY = "ELECTRICITY",
  GAS = "GAS",
  INSURANCE = "INSURANCE",
  INTERNET = "INTERNET",
  SEWAGE = "SEWAGE",
  TRASH = "TRASH",
  WATER = "WATER",
}

export interface CancellationReasonInput {
  additionalDetails?: string | null;
  structuredReasons?: (string | null)[] | null;
}

export interface ClosingTasksInput {
  hoaFees?: HoaFeesTaskInput | null;
  hvacRoof?: HvacRoofTaskInput | null;
  lateCheckout?: LateCheckoutTaskInput | null;
  otherHomeInfo?: OtherHomeInfoTaskInput | null;
  serviceAccounts?: ServiceAccountsTaskInput | null;
  setCloseDate?: SetCloseDateTaskInput | null;
  setSignatories?: SetSignatoriesTaskInput | null;
}

export interface DigitalCheckoutInput {
  declaration: string;
  phoneNumber: string;
  lockboxLocation: string;
  photos?: PhotoInput[] | null;
}

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 * 
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 * 
 * Example 1: Pack and unpack a message in C++.
 * 
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 * 
 * Example 2: Pack and unpack a message in Java.
 * 
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 * 
 *  Example 3: Pack and unpack a message in Python.
 * 
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 * 
 *  Example 4: Pack and unpack a message in Go
 * 
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 * 
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 * 
 * 
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 * 
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 * 
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 * 
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 * 
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 */
export interface GoogleProtobuf_AnyInput {
  typeUrl?: string | null;
  value?: string | null;
}

/**
 * `FieldMask` represents a set of symbolic field paths, for example:
 * 
 *     paths: "f.a"
 *     paths: "f.b.d"
 * 
 * Here `f` represents a field in some root message, `a` and `b`
 * fields in the message found in `f`, and `d` a field found in the
 * message in `f.b`.
 * 
 * Field masks are used to specify a subset of fields that should be
 * returned by a get operation or modified by an update operation.
 * Field masks also have a custom JSON encoding (see below).
 * 
 * # Field Masks in Projections
 * 
 * When used in the context of a projection, a response message or
 * sub-message is filtered by the API to only contain those fields as
 * specified in the mask. For example, if the mask in the previous
 * example is applied to a response message as follows:
 * 
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *         x : 2
 *       }
 *       y : 13
 *     }
 *     z: 8
 * 
 * The result will not contain specific values for fields x,y and z
 * (their value will be set to the default, and omitted in proto text
 * output):
 * 
 * 
 *     f {
 *       a : 22
 *       b {
 *         d : 1
 *       }
 *     }
 * 
 * A repeated field is not allowed except at the last position of a
 * paths string.
 * 
 * If a FieldMask object is not present in a get operation, the
 * operation applies to all fields (as if a FieldMask of all fields
 * had been specified).
 * 
 * Note that a field mask does not necessarily apply to the
 * top-level response message. In case of a REST get operation, the
 * field mask applies directly to the response, but in case of a REST
 * list operation, the mask instead applies to each individual message
 * in the returned resource list. In case of a REST custom method,
 * other definitions may be used. Where the mask applies will be
 * clearly documented together with its declaration in the API.  In
 * any case, the effect on the returned resource/resources is required
 * behavior for APIs.
 * 
 * # Field Masks in Update Operations
 * 
 * A field mask in update operations specifies which fields of the
 * targeted resource are going to be updated. The API is required
 * to only change the values of the fields as specified in the mask
 * and leave the others untouched. If a resource is passed in to
 * describe the updated values, the API ignores the values of all
 * fields not covered by the mask.
 * 
 * If a repeated field is specified for an update operation, new values will
 * be appended to the existing repeated field in the target resource. Note that
 * a repeated field is only allowed in the last position of a `paths` string.
 * 
 * If a sub-message is specified in the last position of the field mask for an
 * update operation, then new value will be merged into the existing sub-message
 * in the target resource.
 * 
 * For example, given the target message:
 * 
 *     f {
 *       b {
 *         d: 1
 *         x: 2
 *       }
 *       c: [1]
 *     }
 * 
 * And an update message:
 * 
 *     f {
 *       b {
 *         d: 10
 *       }
 *       c: [2]
 *     }
 * 
 * then if the field mask is:
 * 
 *  paths: ["f.b", "f.c"]
 * 
 * then the result will be:
 * 
 *     f {
 *       b {
 *         d: 10
 *         x: 2
 *       }
 *       c: [1, 2]
 *     }
 * 
 * An implementation may provide options to override this default behavior for
 * repeated and message fields.
 * 
 * In order to reset a field's value to the default, the field must
 * be in the mask and set to the default value in the provided resource.
 * Hence, in order to reset all fields of a resource, provide a default
 * instance of the resource and set all fields in the mask, or do
 * not provide a mask as described below.
 * 
 * If a field mask is not present on update, the operation applies to
 * all fields (as if a field mask of all fields has been specified).
 * Note that in the presence of schema evolution, this may mean that
 * fields the client does not know and has therefore not filled into
 * the request will be reset to their default. If this is unwanted
 * behavior, a specific service may require a client to always specify
 * a field mask, producing an error if not.
 * 
 * As with get operations, the location of the resource which
 * describes the updated values in the request message depends on the
 * operation kind. In any case, the effect of the field mask is
 * required to be honored by the API.
 * 
 * ## Considerations for HTTP REST
 * 
 * The HTTP kind of an update operation which uses a field mask must
 * be set to PATCH instead of PUT in order to satisfy HTTP semantics
 * (PUT must only be used for full updates).
 * 
 * # JSON Encoding of Field Masks
 * 
 * In JSON, a field mask is encoded as a single string where paths are
 * separated by a comma. Fields name in each path are converted
 * to/from lower-camel naming conventions.
 * 
 * As an example, consider the following message declarations:
 * 
 *     message Profile {
 *       User user = 1;
 *       Photo photo = 2;
 *     }
 *     message User {
 *       string display_name = 1;
 *       string address = 2;
 *     }
 * 
 * In proto a field mask for `Profile` may look as such:
 * 
 *     mask {
 *       paths: "user.display_name"
 *       paths: "photo"
 *     }
 * 
 * In JSON, the same mask is represented as below:
 * 
 *     {
 *       mask: "user.displayName,photo"
 *     }
 * 
 * # Field Masks and Oneof Fields
 * 
 * Field masks treat fields in oneofs just as regular fields. Consider the
 * following message:
 * 
 *     message SampleMessage {
 *       oneof test_oneof {
 *         string name = 4;
 *         SubMessage sub_message = 9;
 *       }
 *     }
 * 
 * The field mask can be:
 * 
 *     mask {
 *       paths: "name"
 *     }
 * 
 * Or:
 * 
 *     mask {
 *       paths: "sub_message"
 *     }
 * 
 * Note that oneof type names ("test_oneof" in this case) cannot be used in
 * paths.
 * 
 * ## Field Mask Verification
 * 
 * The implementation of any API method which has a FieldMask type field in the
 * request should verify the included field paths, and return an
 * `INVALID_ARGUMENT` error if any path is unmappable.
 */
export interface GoogleProtobuf_FieldMaskInput {
  paths?: string[] | null;
}

/**
 * `ListValue` is a wrapper around a repeated field of values.
 * 
 * The JSON representation for `ListValue` is JSON array.
 */
export interface GoogleProtobuf_ListValueInput {
  values?: GoogleProtobuf_ValueInput[] | null;
}

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 * 
 * The JSON representation for `Struct` is JSON object.
 */
export interface GoogleProtobuf_StructInput {
  fields?: GoogleProtobuf_Struct_FieldsEntryInput[] | null;
}

/**
 * `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`.
 */
export interface GoogleProtobuf_Struct_FieldsEntryInput {
  key?: string | null;
  value?: GoogleProtobuf_ValueInput | null;
}

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 * 
 * The JSON representation for `Value` is JSON value.
 */
export interface GoogleProtobuf_ValueInput {
  kind?: GoogleProtobuf_Value_KindOneofInput | null;
}

export interface GoogleProtobuf_Value_KindOneofInput {
  nullValue?: GoogleProtobuf_NullValue | null;
  numberValue?: number | null;
  stringValue?: string | null;
  boolValue?: boolean | null;
  structValue?: GoogleProtobuf_StructInput | null;
  listValue?: GoogleProtobuf_ListValueInput | null;
}

export interface HoaAmenitiesInput {
  clubhouse?: boolean | null;
  dogPark?: boolean | null;
  golf?: boolean | null;
  gym?: boolean | null;
  other?: boolean | null;
  otherInfo?: string | null;
  park?: boolean | null;
  pool?: boolean | null;
  sauna?: boolean | null;
  sportsCourts?: boolean | null;
  tennisCourt?: boolean | null;
  trails?: boolean | null;
  trashRecycling?: boolean | null;
}

export interface HoaFeeInput {
  amount?: number | null;
  frequency?: string | null;
}

export interface HoaFeesTaskInput {
  hasHoa?: boolean | null;
  hoaAmenities?: HoaAmenitiesInput | null;
  hoaAnswered?: boolean | null;
  hoaFees?: (HoaFeeInput | null)[] | null;
  hoaName?: string | null;
}

export interface HvacRoofTaskInput {
  filedClaim?: boolean | null;
  damageClaimDetails?: string | null;
  hasPolybutenePiping?: boolean | null;
  hasWellWaterSupply?: boolean | null;
  hasSeptic?: boolean | null;
  hasSprinklerOrIrrigation?: boolean | null;
  hasSumpPump?: boolean | null;
  hvacAge?: string | null;
  lastFoundationEvaluation?: string | null;
  receivedProceeds?: boolean | null;
  roofAge?: string | null;
  roofStormDamage?: boolean | null;
  sprinklerTimerType?: SprinklerTimer | null;
  workingSprinkler?: boolean | null;
}

export interface LateCheckoutTaskInput {
  costPerDayCents?: number | null;
  fixedCostCents?: number | null;
  lateCheckoutDate?: string | null;
  numberOfDays?: number | null;
  sellerInterested?: boolean | null;
  totalCostCents?: number | null;
}

export interface OccupantInfo {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
}

/**
 * DEPRECATED: Use SavedSearches in v2 buyer service
 */
export interface OdProtosBuyerData_User_FeedPropertiesFilterInput {
  zones?: OdProtosBuyerData_ZoneInput[] | null;
  propertyTypes?: OdProtosBuyerData_Property_PropertyType[] | null;
  minPrice?: number | null;
  maxPrice?: number | null;
  minBedrooms?: number | null;
  minBathrooms?: number | null;
  minSqft?: number | null;
  maxSqft?: number | null;
  minLotSqft?: number | null;
  maxLotSqft?: number | null;
  minYearBuilt?: number | null;
  maxYearBuilt?: number | null;
  maxMonthlyHoaFee?: number | null;
  isSingleStory?: boolean | null;
  isFhaEligible?: boolean | null;
  hasPool?: boolean | null;
  onlyHomebuilder?: boolean | null;
}

/**
 * DEPRECATED: Use FeedPropertiesFilter
 */
export interface OdProtosBuyerData_User_PropertiesFilterInput {
  zones?: OdProtosBuyerData_ZoneInput[] | null;
  propertyTypes?: OdProtosBuyerData_Property_PropertyType[] | null;
  minPrice?: number | null;
  maxPrice?: number | null;
  minBedrooms?: number | null;
  minBathrooms?: number | null;
  minSqft?: number | null;
  maxSqft?: number | null;
  minLotSqft?: number | null;
  maxLotSqft?: number | null;
  minYearBuilt?: number | null;
  maxYearBuilt?: number | null;
  maxMonthlyHoaFee?: number | null;
  isSingleStory?: boolean | null;
  isFhaEligible?: boolean | null;
  hasPool?: boolean | null;
  onlyHomebuilder?: boolean | null;
}

export interface OdProtosBuyerData_ZoneInput {
  gdsId?: string | null;
}

export interface OdProtosBuyerServicesBuyer_DocumentRequests_AddAppraisalDocumentByOfferIdInput {
  offerId?: string | null;
  s3Key?: string | null;
  name?: string | null;
  amount?: number | null;
}

export interface OdProtosBuyerServicesBuyer_MarketConfigRequests_GetMarketConfigByMarketInput {
  market?: OdProtosCommonMarket_Market | null;
}

export interface OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUserInput {
  paginationRequest?: OdProtosCommonPagination_PaginationRequestInput | null;
  offerFilters?: OdProtosBuyerServicesBuyer_OfferRequests_GetOffersForCurrentUser_OfferFilters | null;
  addressIds?: string[] | null;
}

export interface OdProtosBuyerServicesBuyer_OfferRequests_UpdateOfferLenderInput {
  id?: string | null;
  lenderName?: string | null;
  lenderCompanyName?: string | null;
  lenderEmail?: string | null;
  lenderPhone?: string | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_FavoritePropertyInput {
  addressId?: string | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetFavoritePropertiesForCurrentUserInput {
  paginationRequest?: OdProtosCommonPagination_PaginationRequestInput | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUserInput {
  paginationRequest?: OdProtosCommonPagination_OffsetPaginationRequestInput | null;
  sortKey?: OdProtosBuyerServicesBuyer_PropertyRequests_GetFeedPropertiesForCurrentUser_SortKey | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByGeometryInput {
  shape?: string | null;
  filters?: OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput | null;
  paginationRequest?: OdProtosCommonPagination_OffsetPaginationRequestInput | null;
  sortKey?: OdProtosBuyerServicesBuyer_PropertyRequests_SortKey | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQueryInput {
  queryString?: string | null;
  limit?: number | null;
  location?: OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesByTextQuery_LocationInput {
  latitude?: number | null;
  longitude?: number | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertiesStatsForPropertiesFilterInput {
  propertiesFilter?: OdProtosBuyerData_User_PropertiesFilterInput | null;
  feedPropertiesFilter?: OdProtosBuyerData_User_FeedPropertiesFilterInput | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_GetPropertyMarkersByGeometryInput {
  shape?: string | null;
  filters?: OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput | null;
  sortKey?: OdProtosBuyerServicesBuyer_PropertyRequests_SortKey | null;
}

/**
 * Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry
 */
export interface OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput {
  min?: number | null;
  max?: number | null;
}

/**
 * Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry
 */
export interface OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput {
  min?: number | null;
  max?: number | null;
}

/**
 * Used for GetPropertiesByGeometry and GetPropertyMarkersByGeometry
 */
export interface OdProtosBuyerServicesBuyer_PropertyRequests_PropertyFiltersInput {
  bedrooms?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  bathroomsTotal?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFloatFilterInput | null;
  currentListPrice?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  totalLivingSqFt?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  lotSqFt?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  yearBuilt?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  monthlyHoaDues?: OdProtosBuyerServicesBuyer_PropertyRequests_MinMaxFilterInput | null;
  dwellingTypes?: OdProtosBuyerData_Property_PropertyType[] | null;
  isOpendoorBackedOfferEligible?: boolean | null;
  isOpendoorOwned?: boolean | null;
  hasPool?: boolean | null;
  isFhaEligible?: boolean | null;
  isSingleStory?: boolean | null;
  onlyHomebuilder?: boolean | null;
  onlyInstantTourable?: boolean | null;
}

export interface OdProtosBuyerServicesBuyer_PropertyRequests_RemoveFavoritePropertyInput {
  addressId?: string | null;
}

export interface OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatusInput {
  id?: string | null;
  status?: OdProtosBuyerServicesBuyer_TaskRequests_UpdateTaskStatus_Status | null;
}

export interface OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUserInput {
  paginationRequest?: OdProtosCommonPagination_PaginationRequestInput | null;
  tourFilter?: OdProtosBuyerServicesBuyer_TourRequests_GetToursForCurrentUser_TourFilter | null;
}

export interface OdProtosBuyerServicesBuyer_UserRequests_UpdateUserBuyingPowerInput {
  annualHouseholdIncome?: number | null;
  creditScoreIndicated?: OdProtosBuyerData_User_CreditRating | null;
  downPaymentAmount?: number | null;
  monthlyDebt?: number | null;
}

export interface OdProtosBuyerServicesBuyer_UserRequests_UpdateUserMarketIdentifierInput {
  marketIdentifier?: OdProtosCommonMarket_Market | null;
}

export interface OdProtosBuyerServicesBuyer_UserRequests_UpdateUserPropertiesFilterForCurrentUserInput {
  propertiesFilter?: OdProtosBuyerData_User_PropertiesFilterInput | null;
  feedPropertiesFilter?: OdProtosBuyerData_User_FeedPropertiesFilterInput | null;
}

export interface OdProtosBuyerServicesBuyer_ZoneRequests_GetZoneSuggestionsByGdsZoneIdsInput {
  gdsZoneIds?: string[] | null;
  forAutoFeedSetup?: boolean | null;
}

export interface OdProtosBuyerServicesBuyer_ZoneRequests_GetZonesByTextQueryInput {
  queryString?: string | null;
  limit?: number | null;
}

/**
 * OffsetPaginationRequest
 * 
 * More lightweight than the PaginationRequest
 * it only allows forward pagination
 */
export interface OdProtosCommonPagination_OffsetPaginationRequestInput {
  count?: number | null;
  offset?: number | null;
}

/**
 * Pagination request.
 * 
 * To enable forward pagination, two arguments are required.
 * * first takes a non‐negative integer.
 * * after takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges after the after cursor, and returning at
 * most first edges.
 * 
 * To enable backward pagination, two arguments are required.
 * * last takes a non‐negative integer.
 * * before takes the cursor type as described in the cursor field section.
 * The server should use those two arguments to modify the edges returned by
 * the connection, returning edges before the before cursor, and returning at
 * most last edges.
 */
export interface OdProtosCommonPagination_PaginationRequestInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
}

export interface OdProtosCommon_DateInput {
  year?: number | null;
  month?: number | null;
  day?: number | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosCommon_EmailAddressInput {
  value?: string | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosCommon_MoneyInput {
  currencyCode?: OdProtosCommon_Money_AlphabeticCurrencyCode | null;
  value?: number | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosCommon_PhoneNumberInput {
  value?: string | null;
}

export interface OdProtosDiscloseData_UpdateReportRequestInput {
  id?: string | null;
  rubric?: OdProtosRubricV2Data_RubricInput | null;
  isFinal?: boolean | null;
  source?: string | null;
  sourceId?: string | null;
}

export interface OdProtosDiscloseServices_IdentifierInput {
  id?: string | null;
  source?: string | null;
}

export interface OdProtosGeoDataStoreServices_SearchZonesByTextQueryRequestInput {
  queryString?: string | null;
  limit?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  types?: OdProtosGeoDataStoreData_Zone_Type[] | null;
  states?: OdProtosCommonState_State[] | null;
  shapeGeoOption?: OdProtosGeoDataStoreServices_ShapeGeoOption | null;
}

/**
 * Records service and user ID (human token rather than username or email which can change).
 * Particularly useful for finding patterns in home detail edits or tracking provenance
 */
export interface OdProtosHomeDataStore_ActorInput {
  systemId?: string | null;
  userId?: string | null;
}

/**
 * HomeDetail represents a view of a Home attributes. These details could come from one source (e.g. MLS) or be the
 * result of merging with multiple sources.
 * 
 * A HomeDetail is uniquely identified by the (source, source_name, source_id, instance_updated_timestamp) tuple.
 * 
 * Next ID: 199
 */
export interface OdProtosHomeDataStore_HomeDetailInput {
  homeDetailId: string;
  addressUuid?: string | null;
  timestamp?: any | null;
  sourceTimestamp?: any | null;
  instanceUpdatedTimestamp?: any | null;
  source?: OdProtosHomeDataStore_HomeDetail_Source | null;
  sourceName?: string | null;
  sourceId?: string | null;
  createdBy?: OdProtosHomeDataStore_ActorInput | null;
  sourceSpecificDetail?: GoogleProtobuf_AnyInput | null;
  bedrooms?: number | null;
  bathroomsFull?: number | null;
  bathroomsHalf?: number | null;
  dwellingType?: string | null;
  totalLivingSqFt?: number | null;
  aboveGradeSqFt?: number | null;
  lotSqFt?: number | null;
  basementSqFt?: number | null;
  basementFinishedSqFt?: number | null;
  basementUnfinishedSqFt?: number | null;
  editedFieldFeedback?: OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput[] | null;
  basementFeatures?: OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput | null;
  parkingFeatures?: OdProtosHomeDataStore_HomeDetail_ParkingFeature[] | null;
  yearBuilt?: number | null;
  garageSpaces?: number | null;
  isGarageAttached?: boolean | null;
  carportSpaces?: number | null;
  isCarportAttached?: boolean | null;
  exteriorStories?: number | null;
  interiorStories?: number | null;
  primaryOwner?: string | null;
  primaryOwnerType?: string | null;
  hasPrivatePool?: boolean | null;
  hasCommunityPool?: boolean | null;
  lastRenovatedDate?: OdProtosCommon_DateInput | null;
  outdoorSpaces?: OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput[] | null;
  poolFeatures?: string[] | null;
  apn?: string | null;
  builderName?: string | null;
  subdivision?: string | null;
  hasSinkhole?: boolean | null;
  hasGarageConversion?: boolean | null;
  subdivisionId?: string | null;
  subdivisionPlanCount?: number | null;
  planSpecCount?: number | null;
  planName?: string | null;
  units?: number | null;
  hvacSystems?: OdProtosHomeDataStore_HomeDetail_HvacSystemInput[] | null;
  coolingFeatures?: OdProtosHomeDataStore_HomeDetail_CoolingFeature[] | null;
  hasAirConditioning?: boolean | null;
  heatingFeatures?: OdProtosHomeDataStore_HomeDetail_HeatingFeature[] | null;
  waterHeaters?: OdProtosHomeDataStore_HomeDetail_WaterHeaterInput[] | null;
  hoas?: OdProtosHomeDataStore_HomeDetail_HoaInput[] | null;
  roomFloorings?: OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput[] | null;
  primaryFlooring?: OdProtosHomeDataStore_HomeDetail_FlooringInput | null;
  secondaryFlooring?: OdProtosHomeDataStore_HomeDetail_FlooringInput | null;
  flooringMaterials?: string[] | null;
  rooms?: OdProtosHomeDataStore_HomeDetail_RoomInput[] | null;
  otherRooms?: OdProtosHomeDataStore_HomeDetail_OtherRoom[] | null;
  fireplaceFeatures?: OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput | null;
  hasFireplace?: boolean | null;
  roomfeatureDiningRoom?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureKitchen?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureFamilyRoom?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureLivingRoom?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureGarage?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureCarport?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureLaundry?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureUnfinishedBasement?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureMasterBedroom?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureMasterBathroom?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureMasterCloset?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureDeck?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeaturePorch?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureDen?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureOffice?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureEntry?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  roomfeatureLoft?: OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput | null;
  condition?: OdProtosHomeDataStore_HomeDetail_ConditionInput | null;
  kitchenApplianceType?: string | null;
  cookingRange?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  dishwasher?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  standaloneStovetop?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  standaloneOven?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  microwave?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  refrigerator?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  garbageDisposal?: OdProtosHomeDataStore_HomeDetail_ApplianceInput | null;
  kitchenCountertop?: string | null;
  kitchenFeatures?: OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput | null;
  diningAreas?: OdProtosHomeDataStore_HomeDetail_DiningArea[] | null;
  bathroomFeatures?: OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput[] | null;
  masterBathroomFeatures?: OdProtosHomeDataStore_HomeDetail_BathroomFeature[] | null;
  laundryFeatures?: OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput | null;
  hasAddition?: boolean | null;
  isAdditionPermitted?: boolean | null;
  additions?: OdProtosHomeDataStore_HomeDetail_AdditionInput[] | null;
  hasKnownFoundationIssues?: boolean | null;
  isAgeRestrictedCommunity?: boolean | null;
  hasHistoryOfChemicalContamination?: boolean | null;
  hasAsbestosSiding?: boolean | null;
  hasWellWater?: boolean | null;
  hasSeptic?: boolean | null;
  isGatedCommunity?: boolean | null;
  isZonedForLivestock?: boolean | null;
  hasHorses?: boolean | null;
  hasFireDamage?: boolean | null;
  hasSolarPanels?: boolean | null;
  solarPanelsOwnership?: string | null;
  masterBedroomFloor?: string | null;
  hasSplitMasterBedroom?: boolean | null;
  drivewaySlopeType?: string | null;
  drivewaySlopeDirection?: string | null;
  hasBackYardRetainingWall?: boolean | null;
  paintNeutral?: string | null;
  kitchenRemodel?: string | null;
  masterBathroomRemodel?: string | null;
  hasBasement?: boolean | null;
  hasCrawlspace?: boolean | null;
  hasVaultedCeiling?: boolean | null;
  constructionMaterials?: string[] | null;
  landscapingFeatures?: string[] | null;
  hasPrivateSpa?: boolean | null;
  hasCommunitySpa?: boolean | null;
  spaFeatures?: string[] | null;
  roofMaterials?: string[] | null;
  roof?: OdProtosHomeDataStore_HomeDetail_RoofInput | null;
  dwellingStyle?: string | null;
  entryType?: string | null;
  facade?: OdProtosHomeDataStore_HomeDetail_FacadeInput | null;
  numFireplaces?: number | null;
  schoolDistrictElementary?: string | null;
  schoolElementary?: string | null;
  schoolDistrictHigh?: string | null;
  schoolHigh?: string | null;
  schoolMiddle?: string | null;
  landscaping?: OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput | null;
  yards?: OdProtosHomeDataStore_HomeDetail_YardInput[] | null;
  frontYard?: OdProtosHomeDataStore_HomeDetail_YardFeaturesInput | null;
  backYard?: OdProtosHomeDataStore_HomeDetail_YardFeaturesInput | null;
  fenceFeatures?: OdProtosHomeDataStore_HomeDetail_FenceFeature[] | null;
  hasNiceBackyard?: boolean | null;
  hasUpgrades?: boolean | null;
  hasNiceCurbAppeal?: boolean | null;
  hasResortStyle?: boolean | null;
  electricalWireMaterial?: string[] | null;
  supplyPipeMaterial?: string[] | null;
  sewerPipeMaterial?: string[] | null;
  lotFeatures?: OdProtosHomeDataStore_HomeDetail_LotFeaturesInput | null;
  foundationType?: string | null;
  sewerType?: string | null;
  block?: string | null;
  lotNumber?: string | null;
  ownership?: string | null;
  taxLegalDescription?: string | null;
  taxes?: number | null;
  taxYear?: number | null;
  hasGatedCommunityGuard?: boolean | null;
  stormShelterType?: string | null;
  hasDen?: boolean | null;
  waterUtilityProviders?: OdProtosHomeDataStore_HomeDetail_UtilityProviderInput[] | null;
  electricUtilityProviders?: OdProtosHomeDataStore_HomeDetail_UtilityProviderInput[] | null;
  gasUtilityProviders?: OdProtosHomeDataStore_HomeDetail_UtilityProviderInput[] | null;
  sewerUtilityProviders?: OdProtosHomeDataStore_HomeDetail_UtilityProviderInput[] | null;
  utilityProviders?: string[] | null;
  attractors?: OdProtosHomeDataStore_HomeDetail_AttractorsInput | null;
  detractors?: OdProtosHomeDataStore_HomeDetail_DetractorsInput | null;
  nearestMotorway?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestTrunk?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestHighwayPrimary?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestHighwaySecondary?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestHighwayTertiary?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestMotorwayLink?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  nearestTrunkLink?: OdProtosHomeDataStore_HomeDetail_RoadInput | null;
  hoa?: OdProtosHomeDataStore_HomeDetail_HoaInput | null;
  kitchenCondition?: string | null;
  bathroomCondition?: string | null;
  backYardCondition?: string | null;
  frontYardCondition?: string | null;
  exteriorFacadeCondition?: string | null;
  interiorPaintCondition?: string | null;
  backYardSlopeType?: string | null;
  backYardSlopeDirection?: string | null;
  imputedSubdivision?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_AdditionInput {
  additionType?: string | null;
  isPermitted?: boolean | null;
  isUpToCode?: boolean | null;
  buildQuality?: string | null;
  additionHvac?: OdProtosHomeDataStore_HomeDetail_Addition_AdditionHvac | null;
  additionSqFt?: number | null;
}

export interface OdProtosHomeDataStore_HomeDetail_ApplianceInput {
  hasAppliance?: boolean | null;
  materialType?: string | null;
  condition?: string | null;
  energyType?: string | null;
}

/**
 * Attractors for a home. Oftentimes these are attributes of the home's surroundings that make it more attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a golf course at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on the golf course)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a golf course)
 */
export interface OdProtosHomeDataStore_HomeDetail_AttractorsInput {
  culDeSac?: number | null;
  golfLot?: number | null;
  lakeLot?: number | null;
  parkGreenLot?: number | null;
  views?: number | null;
  yardLandscaping?: number | null;
  coveredPatio?: number | null;
  coveredPorch?: number | null;
  otherAttractors?: number | null;
  otherAttractorsReason?: string | null;
}

/**
 * Basement features of a home. Common values are: finished, unfinished, crawl_space, egress, partially_finished etc
 */
export interface OdProtosHomeDataStore_HomeDetail_BasementFeaturesInput {
  feature?: string[] | null;
}

export interface OdProtosHomeDataStore_HomeDetail_BathroomFeaturesInput {
  doubleSink?: boolean | null;
  graniteCountertops?: boolean | null;
  separateShowerTub?: boolean | null;
  tileSurround?: boolean | null;
  updatedTileFloors?: boolean | null;
  isMasterBathroom?: boolean | null;
  bathroomType?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_ConditionInput {
  kitchenCondition?: string | null;
  bathroomCondition?: string | null;
  backYardCondition?: string | null;
  frontYardCondition?: string | null;
  exteriorFacadeCondition?: string | null;
  interiorPaintCondition?: string | null;
  fixUpNeedsRepair?: boolean | null;
  property?: number | null;
  kitchen?: number | null;
  bathroom?: number | null;
  interior?: number | null;
  exterior?: number | null;
}

/**
 * Detractors for a home. Oftentimes these are attributes of the home's surroundings that make it less attractive to buyers.
 * Float values should be between 0 and 1
 * 0 means the home does not have the attribute (e.g. it's not near a a busy road at all)
 * 1 means the home is strongly correlated with the attribute (e.g. it's right on a busy road)
 * values between 0 and 1 represent the strength of the correlation (e.g. 0.5 if the home is somewhat near a busy road)
 */
export interface OdProtosHomeDataStore_HomeDetail_DetractorsInput {
  busyRoadArterialConnector?: number | null;
  busyRoadFreewayHighway?: number | null;
  busyRoadMainWithSubdivision?: number | null;
  neighborsIndustrial?: number | null;
  neighborsCommercial?: number | null;
  neighborsMultiFamily?: number | null;
  neighborsSchool?: number | null;
  powerSubstation?: number | null;
  powerHighVoltageTower?: number | null;
  powerHighVoltageWire?: number | null;
  powerLowVoltagePowerline?: number | null;
  railroad?: number | null;
  slopedBackyard?: number | null;
  slopedDriveway?: number | null;
  otherDetractors?: number | null;
  otherDetractorsReason?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_EditedFieldFeedbackInput {
  fieldKey?: string | null;
  dataSource?: string | null;
  editReasons?: string[] | null;
  editContext?: string | null;
}

/**
 * Facade / siding
 */
export interface OdProtosHomeDataStore_HomeDetail_FacadeInput {
  material?: string[] | null;
  condition?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_FenceInput {
  fenceMaterials?: string[] | null;
}

export interface OdProtosHomeDataStore_HomeDetail_FireplaceFeaturesInput {
  locations?: OdProtosHomeDataStore_HomeDetail_Location[] | null;
  features?: OdProtosHomeDataStore_HomeDetail_FireplaceFeature[] | null;
}

export interface OdProtosHomeDataStore_HomeDetail_FireplaceInput {
  fireplaceType?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_FlooringInput {
  material?: string | null;
  flooringMaterial?: OdProtosHomeDataStore_HomeDetail_FlooringMaterial | null;
  condition?: string | null;
  squareFeet?: number | null;
  lengthFeet?: number | null;
  widthFeet?: number | null;
}

/**
 * Home Owner's Association data.
 */
export interface OdProtosHomeDataStore_HomeDetail_HoaInput {
  name?: string | null;
  rules?: string | null;
  hoaType?: OdProtosHomeDataStore_HomeDetail_Hoa_HoaType | null;
  fee?: OdProtosCommon_MoneyInput | null;
  feeFrequency?: string | null;
  feeMinimum?: OdProtosCommon_MoneyInput | null;
  feeMaximum?: OdProtosCommon_MoneyInput | null;
  feeType?: OdProtosHomeDataStore_HomeDetail_Hoa_HoaFeeType | null;
  includes?: string[] | null;
  hasLeasingRestriction?: boolean | null;
  companyName?: string | null;
  lawFirmName?: string | null;
  contact?: OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput[] | null;
}

export interface OdProtosHomeDataStore_HomeDetail_Hoa_ContactInput {
  type?: OdProtosHomeDataStore_HomeDetail_Hoa_Contact_Type | null;
  name?: string | null;
  businessPhone?: OdProtosCommon_PhoneNumberInput | null;
  mobilePhone?: OdProtosCommon_PhoneNumberInput | null;
  email?: OdProtosCommon_EmailAddressInput | null;
  address?: OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput | null;
}

export interface OdProtosHomeDataStore_HomeDetail_Hoa_Contact_AddressInput {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  unitNumber?: string | null;
  country?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_HvacInput {
  hvacUnitType?: OdProtosHomeDataStore_HomeDetail_HvacUnitType | null;
  hvacLocation?: OdProtosHomeDataStore_HomeDetail_HvacLocation | null;
  yearManufactured?: number | null;
  serialNumber?: string | null;
  manufacturer?: string | null;
  model?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_HvacSystemInput {
  systemType?: OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacSystemType | null;
  energyType?: OdProtosHomeDataStore_HomeDetail_HvacSystem_HvacEnergyType | null;
  hvacs?: OdProtosHomeDataStore_HomeDetail_HvacInput[] | null;
}

/**
 * An inclusive range of integer values.
 */
export interface OdProtosHomeDataStore_HomeDetail_IntegerRangeInput {
  start?: number | null;
  end?: number | null;
}

export interface OdProtosHomeDataStore_HomeDetail_KitchenFeaturesInput {
  kitchenIsland?: boolean | null;
  newCabinets?: boolean | null;
  tileBacksplash?: boolean | null;
  hasPantry?: boolean | null;
  hasWaterLineToFridge?: boolean | null;
  hasVentMechanism?: boolean | null;
  hasExhaustFanOrHood?: boolean | null;
  hasCeilingFan?: boolean | null;
  hasPlumbedGas?: boolean | null;
  hasCablePrewire?: boolean | null;
  hasWalkInPantry?: boolean | null;
  hasBuiltInMicrowave?: boolean | null;
  hasWallOven?: boolean | null;
  hasMultipleOvens?: boolean | null;
  hasDoubleOven?: boolean | null;
  noAppliances?: boolean | null;
  hasCookingIsland?: boolean | null;
  hasFoodPrepIsland?: boolean | null;
  hasButlerPantry?: boolean | null;
  galley?: boolean | null;
  hasWetBar?: boolean | null;
  kitchenette?: boolean | null;
  hasSkylight?: boolean | null;
  openFloorPlan?: boolean | null;
  hasRecessedLighting?: boolean | null;
  none?: boolean | null;
  other?: boolean | null;
}

export interface OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput {
  hasDesertYard?: boolean | null;
  sprinklerSystem?: boolean | null;
  grass?: boolean | null;
  syntheticGrass?: boolean | null;
  lowMaintenance?: boolean | null;
  gravelStone?: boolean | null;
  garden?: boolean | null;
  shrubs?: boolean | null;
  decorativeLighting?: boolean | null;
  trees?: boolean | null;
  fountain?: boolean | null;
  dirt?: boolean | null;
  noLandscaping?: boolean | null;
  fruitTrees?: boolean | null;
  matureLandscaping?: boolean | null;
}

export interface OdProtosHomeDataStore_HomeDetail_LaundryFeaturesInput {
  location?: OdProtosHomeDataStore_HomeDetail_Location | null;
  features?: OdProtosHomeDataStore_HomeDetail_LaundryFeature[] | null;
}

/**
 * Next LotFeature ID: 13;
 */
export interface OdProtosHomeDataStore_HomeDetail_LotFeaturesInput {
  isCulDeSac?: boolean | null;
  isCornerLot?: boolean | null;
  perimeterFeet?: number | null;
  isCleared?: boolean | null;
  isFlagLot?: boolean | null;
  isGreenbelt?: boolean | null;
  isInteriorLot?: boolean | null;
  isIrregularLot?: boolean | null;
  isLandscaped?: boolean | null;
  onGolfCourse?: boolean | null;
  onWaterfront?: boolean | null;
  other?: boolean | null;
}

export interface OdProtosHomeDataStore_HomeDetail_OutdoorSpaceInput {
  type?: string | null;
  location?: string | null;
  isCovered?: boolean | null;
  isCoverPermitted?: boolean | null;
}

/**
 * Road represents segments of both Road and Links (onRamps)
 */
export interface OdProtosHomeDataStore_HomeDetail_RoadInput {
  label?: string | null;
  distanceM?: number | null;
  adjacent?: boolean | null;
  roadWkt?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_RoofInput {
  roofMaterials?: string[] | null;
  hasEvidenceOfHailDamage?: boolean | null;
  hasEvidenceOfLeakFromInterior?: boolean | null;
  isRoofMaintainedByHoa?: boolean | null;
  estimatedLifeExpiration?: OdProtosHomeDataStore_HomeDetail_IntegerRangeInput | null;
  yearBuilt?: number | null;
}

export interface OdProtosHomeDataStore_HomeDetail_RoomFeaturesInput {
  interiorStory?: number | null;
  squareFeet?: number | null;
  lengthFeet?: number | null;
  widthFeet?: number | null;
  fireplaceFeatures?: OdProtosHomeDataStore_HomeDetail_FireplaceFeature[] | null;
  flooringMaterial?: OdProtosHomeDataStore_HomeDetail_FlooringMaterial | null;
  roomFloorings?: OdProtosHomeDataStore_HomeDetail_FlooringInput[] | null;
}

/**
 * `OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput` represents the `room_floorings` map in `od_protos.home_data_store.HomeDetail`.
 */
export interface OdProtosHomeDataStore_HomeDetail_RoomFlooringsEntryInput {
  key?: string | null;
  value?: OdProtosHomeDataStore_HomeDetail_FlooringInput | null;
}

/**
 * Deprecated, use top-level fields for available rooms.
 * Remaining ambiguous rooms can continue to be listed here
 * Ex. bedroom (non-master), bathroom (non-master), hallway, closet, storage
 * Next Room Id: 11
 */
export interface OdProtosHomeDataStore_HomeDetail_RoomInput {
  roomType?: string | null;
  roomSubType?: string | null;
  story?: string | null;
  flooringMaterial?: string | null;
  flooringCondition?: string | null;
  squareFeet?: number | null;
  lengthFeet?: number | null;
  widthFeet?: number | null;
  fireplaces?: OdProtosHomeDataStore_HomeDetail_FireplaceInput[] | null;
  roomFloorings?: OdProtosHomeDataStore_HomeDetail_FlooringInput[] | null;
}

export interface OdProtosHomeDataStore_HomeDetail_UtilityProviderInput {
  providerName?: string | null;
}

export interface OdProtosHomeDataStore_HomeDetail_WaterHeaterInput {
  yearInstalled?: number | null;
  features?: string[] | null;
  energyType?: OdProtosHomeDataStore_HomeDetail_WaterHeater_WaterHeaterEnergyType | null;
  capacityGallons?: OdProtosHomeDataStore_HomeDetail_IntegerRangeInput | null;
}

export interface OdProtosHomeDataStore_HomeDetail_YardFeaturesInput {
  hasYard?: boolean | null;
  slopeType?: OdProtosHomeDataStore_HomeDetail_SlopeType | null;
  slopeDirection?: OdProtosHomeDataStore_HomeDetail_SlopeDirection | null;
  fenceCompletionStatus?: OdProtosHomeDataStore_HomeDetail_YardFeatures_FenceCompletionStatus | null;
  fenceFeatures?: OdProtosHomeDataStore_HomeDetail_FenceFeature[] | null;
  landscaping?: OdProtosHomeDataStore_HomeDetail_LandscapingFeaturesInput | null;
}

/**
 * Deprecated, use yard features instead
 * Next Yard ID: 7;
 */
export interface OdProtosHomeDataStore_HomeDetail_YardInput {
  hasYard?: boolean | null;
  position?: string | null;
  condition?: string | null;
  slopeType?: string | null;
  slopeDirection?: string | null;
  fence?: OdProtosHomeDataStore_HomeDetail_FenceInput | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosMortgageData_CreditRangeInput {
  min?: number | null;
  max?: number | null;
}

/**
 * Attributes contains additional information regarding a referral. Intended to store
 * details and fields that might be subject to change.
 * 
 * Next ID: 14
 */
export interface OdProtosPartnershipData_Referral_AttributesInput {
  eligibleForAgentReferralPayment?: boolean | null;
  otherBuilderName?: string | null;
  unknownSalesAssociateEmail?: string | null;
  referralHandoverOccurredAt?: string | null;
  brokerageName?: string | null;
  brokerageAddress?: string | null;
  agentRealEstateLicenseNumber?: string | null;
  agentRealEstateLicenseState?: string | null;
  webhooksSentAt?: OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput[] | null;
  offerRequestedAt?: string | null;
  elaResaleFlipToken?: string | null;
  elaPassbackDate?: any | null;
  elaTakebackDate?: any | null;
  elaActionUpdated?: any | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosPartnershipData_Referral_Attributes_WebhookSentAtInput {
  eventName?: string | null;
  webhookSentAt?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosPartnershipServices_AcceptReferralInvitationRequestInput {
  invitationId?: string | null;
}

/**
 * Next ID: 18
 */
export interface OdProtosPartnershipServices_CreateOrUpdateReferralForSellerInputRequestInput {
  sellerInputId?: string | null;
  leadToken?: string | null;
  partnershipType?: OdProtosPartnershipData_PartnershipType | null;
  partnerIdentifier?: string | null;
  organizationId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  regionIdentifier?: string | null;
  source?: OdProtosPartnershipData_Referral_Source | null;
  sellerRelation?: OdProtosPartnershipData_Referral_SellerRelation | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  externalTrackingId?: string | null;
  attributes?: OdProtosPartnershipData_Referral_AttributesInput | null;
  attributesMask?: GoogleProtobuf_FieldMaskInput | null;
  attributionType?: OdProtosPartnershipData_Referral_AttributionType | null;
  rootSellerInputId?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosPartnershipServices_DeclineReferralInvitationRequestInput {
  invitationId?: string | null;
}

/**
 * Next ID: 11
 * 
 * Params after AttributionType are unnecessary if opting to represent.
 */
export interface OdProtosPartnershipServices_ReferOrRepresentCustomerRequestInput {
  referralId?: string | null;
  attributionType?: OdProtosPartnershipData_Referral_AttributionType | null;
  customerFirstName?: string | null;
  customerLastName?: string | null;
  customerEmail?: string | null;
  brokerageName?: string | null;
  brokerageAddress?: string | null;
  agentRealEstateLicenseNumber?: string | null;
  agentRealEstateLicenseState?: string | null;
  customerPhoneNumber?: string | null;
}

export interface OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput {
  id?: string | null;
  key?: string | null;
  title?: string | null;
  required?: boolean | null;
  tags?: string[] | null;
  prompts?: OdProtosRubricV2Data_PromptInput[] | null;
  allowedFollowupPrompts?: OdProtosRubricV2Data_PromptInput[] | null;
}

export interface OdProtosRubricV2Data_FollowUpPromptGroupInput {
  promptGroupId?: string | null;
  promptGroupKey?: string | null;
  triggeringAnswers?: string[] | null;
  expectedAnswers?: string[] | null;
}

export interface OdProtosRubricV2Data_FollowUpPromptInput {
  promptId?: string | null;
  promptKey?: string | null;
  triggeringAnswers?: string[] | null;
  expectedAnswers?: string[] | null;
}

export interface OdProtosRubricV2Data_OptionBehaviorInput {
  action?: OdProtosRubricV2Data_OptionBehavior_Action | null;
  comment?: string | null;
  assetIds?: string[] | null;
}

export interface OdProtosRubricV2Data_OptionInput {
  displayText?: string | null;
  value?: string | null;
  optionBehavior?: OdProtosRubricV2Data_OptionBehaviorInput | null;
}

export interface OdProtosRubricV2Data_PreviousVisitDataInput {
  photoUrls?: string[] | null;
  comments?: string[] | null;
}

export interface OdProtosRubricV2Data_PromptBehaviorInput {
  behavior?: OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput | null;
}

export interface OdProtosRubricV2Data_PromptBehavior_BehaviorOneofInput {
  textValidation?: OdProtosRubricV2Data_TextValidationInput | null;
  followUpPrompt?: OdProtosRubricV2Data_FollowUpPromptInput | null;
  followUpPromptGroup?: OdProtosRubricV2Data_FollowUpPromptGroupInput | null;
  promptGroupAddition?: OdProtosRubricV2Data_PromptGroupAdditionInput | null;
}

export interface OdProtosRubricV2Data_PromptGroupAdditionInput {
  condition?: OdProtosRubricV2Data_PromptGroupAddition_Condition | null;
  promptGroupId?: string | null;
}

export interface OdProtosRubricV2Data_PromptGroupInput {
  id?: string | null;
  key?: string | null;
  title?: string | null;
  required?: boolean | null;
  tags?: string[] | null;
  prompts?: OdProtosRubricV2Data_PromptInput[] | null;
  allowedFollowupPrompts?: OdProtosRubricV2Data_PromptInput[] | null;
  allowedFollowupPromptGroups?: OdProtosRubricV2Data_AllowedFollowUpPromptGroupInput[] | null;
}

export interface OdProtosRubricV2Data_PromptInput {
  id?: string | null;
  key?: string | null;
  displayText?: string | null;
  description?: string | null;
  type?: OdProtosRubricV2Data_Prompt_Type | null;
  promptBehaviors?: OdProtosRubricV2Data_PromptBehaviorInput[] | null;
  required?: boolean | null;
  tags?: string[] | null;
  options?: OdProtosRubricV2Data_OptionInput[] | null;
  response?: OdProtosRubricV2Data_Prompt_ResponseOneofInput | null;
  previousVisit?: OdProtosRubricV2Data_PreviousVisitDataInput | null;
}

export interface OdProtosRubricV2Data_Prompt_ResponseOneofInput {
  text?: string | null;
  selectedOptions?: OdProtosRubricV2Data_SelectedOptionsInput | null;
  photos?: OdProtosRubricV2Data_UploadedPhotosInput | null;
  videos?: OdProtosRubricV2Data_UploadedVideosInput | null;
}

export interface OdProtosRubricV2Data_RegexValidationInput {
  regex?: string | null;
  explanation?: string | null;
}

export interface OdProtosRubricV2Data_RubricInput {
  id: string;
  key?: string | null;
  title?: string | null;
  description?: string | null;
  promptGroups?: OdProtosRubricV2Data_PromptGroupInput[] | null;
  cloneablePromptGroups?: OdProtosRubricV2Data_PromptGroupInput[] | null;
}

export interface OdProtosRubricV2Data_SelectedOptionsInput {
  values?: string[] | null;
}

export interface OdProtosRubricV2Data_TextValidationInput {
  answerTypeValidation?: OdProtosRubricV2Data_TextValidation_AnswerTypeValidation | null;
  lowerBoundValidation?: number | null;
  upperBoundValidation?: number | null;
  regexValidation?: OdProtosRubricV2Data_RegexValidationInput | null;
}

export interface OdProtosRubricV2Data_UploadedPhotosInput {
  assetIds?: string[] | null;
}

export interface OdProtosRubricV2Data_UploadedVideosInput {
  assetIds?: string[] | null;
}

/**
 * LeadId represents a lead input, currently including a lead id (seller_uuid) or a lead source (e.g. reception type and seller_input_uuid).
 * Next ID: 3
 */
export interface OdProtosSellSellerData_LeadIdInput {
  lead?: OdProtosSellSellerData_LeadId_LeadOneofInput | null;
}

export interface OdProtosSellSellerData_LeadId_LeadOneofInput {
  leadId?: string | null;
  source?: OdProtosSellSellerData_Lead_SourceInput | null;
}

/**
 * Which system generated the lead.
 */
export interface OdProtosSellSellerData_Lead_SourceInput {
  type?: OdProtosSellSellerData_Lead_Source_Type | null;
  id?: string | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosSellSellerServices_GetLatestLeadRequestInput {
  customerUuid?: string | null;
  addressUuid?: string | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosSellSellerServices_RefreshOffersSingleLeadRequestInput {
  leadId?: OdProtosSellSellerData_LeadIdInput | null;
  offerRequestSource?: OdProtosCommonSell_OfferRequest_Source | null;
}

/**
 * any filters we want to query by, beyond the required zip + market
 * Next ID: 3
 */
export interface OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput {
  bedrooms?: string | null;
  bathrooms?: string | null;
}

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export interface OdProtosVariantData_GrainInput {
  id?: OdProtosVariantData_Grain_IdOneofInput | null;
  grain?: OdProtosVariantData_Grain_GrainOneofInput | null;
}

export interface OdProtosVariantData_Grain_CustomerGrainInput {
  primaryId?: OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput | null;
  temporaryId?: OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput {
  customerUuid?: string | null;
}

export interface OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput {
  anonymousId?: string | null;
}

export interface OdProtosVariantData_Grain_GrainOneofInput {
  customer?: OdProtosVariantData_Grain_CustomerGrainInput | null;
  property?: OdProtosVariantData_Grain_PropertyGrainInput | null;
  operator?: OdProtosVariantData_Grain_OperatorGrainInput | null;
}

export interface OdProtosVariantData_Grain_IdOneofInput {
  customerUuid?: string | null;
  anonymousId?: string | null;
}

export interface OdProtosVariantData_Grain_OperatorGrainInput {
  primaryId?: OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput {
  humanToken?: string | null;
}

export interface OdProtosVariantData_Grain_PropertyGrainInput {
  primaryId?: OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput | null;
  temporaryId?: OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput {
  addressToken?: string | null;
}

export interface OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput {
  propertyEngagementId?: string | null;
}

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export interface OdProtosVariantV2Data_GrainInput {
  grain?: OdProtosVariantV2Data_Grain_GrainOneofInput | null;
}

export interface OdProtosVariantV2Data_Grain_CustomerGrainInput {
  customerUuid?: string | null;
  temporaryId?: OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneofInput {
  anonymousId?: string | null;
}

export interface OdProtosVariantV2Data_Grain_GrainOneofInput {
  customer?: OdProtosVariantV2Data_Grain_CustomerGrainInput | null;
  property?: OdProtosVariantV2Data_Grain_PropertyGrainInput | null;
  operator?: OdProtosVariantV2Data_Grain_OperatorGrainInput | null;
}

export interface OdProtosVariantV2Data_Grain_OperatorGrainInput {
  humanToken?: string | null;
}

export interface OdProtosVariantV2Data_Grain_PropertyGrainInput {
  addressToken?: string | null;
  temporaryId?: OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput | null;
}

export interface OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneofInput {
  propertyEngagementId?: string | null;
}

/**
 * Next ID: 7
 */
export interface OdProtosWebData_ParticipantInput {
  id?: string | null;
  email?: string | null;
  roles?: OdProtosWebData_ParticipantRole[] | null;
  fullName?: string | null;
  createdAt?: any | null;
  humanId?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosWebData_ParticipantRolesForAccessInput {
  participantRolesForAccess?: OdProtosWebData_ParticipantRole[] | null;
}

/**
 * Next ID: 5
 */
export interface OdProtosWebData_VirtualAssessmentRecordingInput {
  id?: string | null;
  recordedFeature?: OdProtosWebData_RecordedFeature | null;
  fileName?: string | null;
  s3Directory?: string | null;
  preSignedRecordingUrl?: string | null;
}

export interface OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput {
  name?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
}

export interface OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput {
  s3Path?: string | null;
  name?: string | null;
}

export interface OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput {
  listingId?: string | null;
  addressToken?: string | null;
}

/**
 * Enrolls in the Exclusive Offers program
 * Next ID: 2
 */
export interface OdProtosWebServicesExclusiveOffers_EnrollInExclusiveOffersRequestInput {
  leadUuid?: string | null;
}

/**
 * Next ID: 3
 */
export interface OdProtosWebServicesMultipartUploads_MultipartUploadPartInput {
  partNumber?: number | null;
  etag?: string | null;
}

/**
 * Next ID: 2
 */
export interface OdProtosWebServicesWebMarket_GetMarketRequestInput {
  identifier?: string | null;
}

export interface OtherHomeInfoTaskInput {
  additionalInfo?: string | null;
  hadPlumbingRepairs?: boolean | null;
  hadPlumbingRepairsDetails?: string | null;
  hasDispute?: boolean | null;
  hasDisputeDetails?: string | null;
  hasEncroachedOrSharedProperty?: boolean | null;
  hasEncroachedOrSharedPropertyDetails?: string | null;
  hasWaterDamage?: boolean | null;
  hasWaterDamageDetails?: string | null;
  mailboxNumber?: string | null;
  recyclingCollection?: string | null;
  trashCollection?: string | null;
  occupancyStatusAtAcquisition?: string | null;
}

export interface PhotoInput {
  url: string;
  mimeType: string;
  photoIdentifier: string;
  fileName: string;
  kind: string;
}

/**
 * The resale contract details that a customer may request changes
 */
export interface ResaleContractDetails {
  buyerFullName?: string | null;
  buyerPhoneNumber?: string | null;
  buyerEmail?: string | null;
  coBuyerFullName?: string | null;
  coBuyerPhoneNumber?: string | null;
  coBuyerEmail?: string | null;
  lenderName?: string | null;
  lenderCompanyName?: string | null;
  lenderPhone?: string | null;
  lenderEmail?: string | null;
  loanType?: ResaleContractDetailsLoanType | null;
}

export interface ServiceAccountsTaskInput {
  coolingType?: string | null;
  electricity?: string | null;
  gas?: string | null;
  hasExistingWaterIssue?: boolean | null;
  hasExistingWaterIssueDetails?: string | null;
  hasSewerSepticIssue?: boolean | null;
  hasSewerSepticIssueDetails?: string | null;
  heatingType?: string | null;
  water?: string | null;
}

export interface SetCloseDateTaskInput {
  selectedDate?: string | null;
}

export interface SetSignatoriesTaskInput {
  signerNames?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
